export const setSalesOrderStatusStatus = (state, payload) => {
	var salesOrderStatussess = [];
	var salesOrderQuotes = [];
	for (var s in payload.salesOrders) {
		if (!salesOrderStatussess.hasOwnProperty(payload.salesOrders[s].quote_id)) {
			salesOrderStatussess[payload.salesOrders[s].quote_id] = [];
			salesOrderQuotes.push({ quoteId: payload.salesOrders[s].quote_id, statusChangeable: true });
		}
		salesOrderStatussess[payload.salesOrders[s].quote_id].push(payload.salesOrders[s].statusId);
	}

	for (var k in salesOrderStatussess) {
		var initialStatus = salesOrderStatussess[k][0];
		for (var s in salesOrderStatussess[k]) {
			if (initialStatus != salesOrderStatussess[k][s]) {
				for (var so in salesOrderQuotes) {
					if (salesOrderQuotes[so].quoteId == k) {
						salesOrderQuotes[so].statusChangeable = false;
					}
				}
			}
		}
	}

	state.salesOrderStatusses = salesOrderQuotes;
}

export const setDashboardData = (state, payload, rootState) => {

  state.newReportFilters = payload.dashData.filters;
  state.newReportFilters = [];
  state.dashboardData = payload.dashData.quotes;

  setTimeout(function(){
    state.newReportFilters = payload.dashData.filters;
    ///localStorage.setItem('newReportFilters', JSON.stringify(payload.dashData.filters));
    state.isLoaded = true;
  }, 1)

}


export const setQuoteList = (state, payload, rootState) => {

  state.totalQuoteRecords = 0;

  if( payload != null && payload && payload.page_start == '0' && payload.quotes.length > 0 ) {
    state.totalQuoteRecords = payload.quotes[0].total_records;
  } else if(payload.quotes.length > 0){
    state.totalQuoteRecords = payload.quotes[0].total_records;
  }

  var ignoreFilters = false;

  if( payload.ignoreFilters != undefined && payload.ignoreFilters != null ) { ignoreFilters = payload.ignoreFilters; }

  var quotes = payload.quotes;

  var vendorActive = JSON.parse(JSON.parse(window.localStorage.vuex).objAuthorize).vendorActive;

  if( payload.loggedUser.privileges.indexOf('QUOTES_VIEW_ALL') == -1 || payload.loggedUser.privileges.indexOf('QUOTES_VIEW_ALL_PUBLIC') == -1 ) {
    if( payload.loggedUser.branch_active == true || payload.loggedUser.branch_active == 1 ) {
    }
  }

  if( payload.loggedUser.privileges.indexOf('QUOTES_VIEW_ALL') == -1 || payload.loggedUser.privileges.indexOf('QUOTES_VIEW_ALL_PUBLIC') == -1 ) {
    if( payload.loggedUser.department_active == true || payload.loggedUser.department_active == 1 ) {
    }
  }

  var statusColours = [];
  for( var s in state.statusList ) {
    if( state.statusList[s].style_colour == '#cccccc' ) {
      state.statusList[s].style_colour = '#ffffff';
    }
    statusColours[state.statusList[s].description] = state.statusList[s].style_colour;
  }

  for (var q in quotes) {
    quotes[q].backgroundColour = statusColours[quotes[q].status];
    if( quotes[q].new_responsible_reps_ids != null && quotes[q].new_responsible_reps_ids != '' ) {
      quotes[q].new_responsible_reps_ids_obj = quotes[q].new_responsible_reps_ids.split(',');
    }
  }

  if (window.localStorage.reportSpecifiers != null && window.localStorage.reportSpecifiers != 'undefined' && ignoreFilters == false) {
    var storageFilter = JSON.parse(window.localStorage.reportSpecifiers);
    var filteredSearch = [];
    for (var s in quotes) {
      for (var c in storageFilter) {
        if ( quotes[s].specifier != null && quotes[s].specifier == storageFilter[c] ) {
          filteredSearch.push(quotes[s]);
        }
      }
    }
    quotes = filteredSearch;
  }

  var isProcess = false;

  for( var s in state.objQuoteSettings ) {
    if( state.objQuoteSettings[s].id == 'process_order' ) {
      isProcess = true;
    }
  }

  var finalSettings = []
  for( var s in state.objQuoteSettings ) {

    finalSettings.push(state.objQuoteSettings[s]);
    if( state.objQuoteSettings[s].id == 'status' && isProcess == false ) {
      var addProcess = { checked: true, id: 'process_order', label: 'Process Order', order: s+2, width: '200px'  };
      finalSettings.push(addProcess);
    }
  }

  state.objQuoteSettings = finalSettings;

  state.quoteList = [];
  state.quoteSearchList = [];
  state.quoteSearchListSet = [];

  state.quoteList = payload.quotes;
  state.quoteSearchList = quotes;
  state.quoteSearchListSet = quotes;

  var lowestDate = '99999999';
  var highestDate = '0';

  for (var v in quotes) {
    var quoteDate = quotes[v].quote_date.replace(/-/g, "");
    var hDate = highestDate.replace(/-/g, "");
    var lDate = lowestDate.replace(/-/g, "");
    if (quoteDate > hDate) {
      highestDate = quotes[v].quote_date;
    }
    if (quoteDate < lDate) {
      lowestDate = quotes[v].quote_date;
    }
  }

  var fStatus = [];
  var fDepartment = [];
  var fOriginator = [];
  var fProjects = [];
  var fSpecifier = [];
  var fUser = [];
  var fCompany = [];
  var fVendor = [];
  var fBranch = [];

  //payload.quotes = state.quoteSearchList;
  if( payload.loggedUser.department != '' && payload.loggedUser.department != null  /*&& ignoreFilters == false*/) {

  }

  state.quoteSearchList = quotes;
  state.quoteSearchListSet = quotes;

  // check for logged in department user
  for( var s in quotes ) {
    var objItem = quotes[s];
    var returnDepartment = 0;
    var departmentName = [];
    if( objItem.range_id != null && objItem.range_id != undefined ) {
      var departmentRanges = payload.departments;
      var filteredQuotes = [];
      var quoteRanges = objItem.range_id.split(',');
      for( var d in departmentRanges ) {
        for( var qr in quoteRanges ) {
          for( var dr in departmentRanges[d].ranges ) {
            if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
              departmentName.push( departmentRanges[d].id );
            }
          }
        }
      }
      var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
      if( uniqueDepartment.length == 0 ) {
        if( objItem.originator_department != '' && objItem.originator_department != null ) {
          for( var d in payload.departments ) {
            if( payload.departments[d].id == objItem.originator_department ) {
              returnDepartment = payload.departments[d].id;
            }
          }
        } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
          returnDepartment = objItem.departmentUser;
        } else {
          returnDepartment = 0;
        }
      } else if( uniqueDepartment.length > 1 ) {
        if( objItem.originator_department != '' && objItem.originator_department != null ) {
          returnDepartment = objItem.originator_department;
        } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
          returnDepartment = objItem.departmentUser;
        } else {
          returnDepartment = 0;
        }
      } else {
        returnDepartment = uniqueDepartment[0];
      }
    } else {
      if( objItem.originator_department != '' && objItem.originator_department != null ) {
        returnDepartment = objItem.originator_department;
      } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
        returnDepartment = objItem.departmentUser;
      } else {
        returnDepartment = 0;
      }
    }

  }
  var savedStores = [];

  if( payload.branches != undefined && payload.branches.length > 0 ) {
    for( var b in payload.branches ) {
      if( payload.branches[b].code != null ) {
        savedStores[payload.branches[b].code.toString()] = payload.branches[b].name;
      }
    }
  }

  if( ( payload.loggedUser.department_active == true || payload.loggedUser.department_active == 1 ) && ( payload.loggedUser.department_status_share == true || payload.loggedUser.department_status_share == 1 )) {
    var labeledStatuses = [];
    var loadedStatuses = [];
    var hasAddedLevel = [];

    for( var l in state.statusList ) {
      loadedStatuses[state.statusList[l].description] = state.statusList[l].departmentName;
    }

    var filterStatus = [{ id: 'all', name: 'All' }];

    var filterByLabel = [];
    for( var l in labeledStatuses ) {
      if( l == 'General') {
        filterByLabel[l] = labeledStatuses[l];
      }
    }
    for( var l in labeledStatuses ) {
      if( l != 'General') {
        filterByLabel[l] = labeledStatuses[l];
      }
    }

    labeledStatuses = filterByLabel;
    for( var k in labeledStatuses ) {
      filterStatus.push({ header: k});
      for( var s in labeledStatuses[k] ) {
        filterStatus.push({ id: labeledStatuses[k][s].id, name: labeledStatuses[k][s].name});
      }
    }
  }

	state.quotesLoaded = true;

  state.isLoaded = true;

}


export const setQuoteListNew = (state, payload, rootState) => {

  var ignoreFilters = false;

  if( payload.ignoreFilters != undefined && payload.ignoreFilters != null ) { ignoreFilters = payload.ignoreFilters; }

  var quotes = payload.quotes;

  var vendorActive = JSON.parse(JSON.parse(window.localStorage.vuex).objAuthorize).vendorActive;

  if (window.localStorage.reportDates != null && window.localStorage.reportDates != 'undefined') {

    var storageFilter = window.localStorage.reportDates.split(',');

    if( storageFilter[0] != '' && storageFilter[0] != '1900-01-01' ) {
      var startDate = new Date(storageFilter[0]);
      startDate.setDate(startDate.getDate() + 1);
      startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);
      startDate = startDate.split("-");
      startDate = startDate[0] + startDate[1] + startDate[2];

      var endDate = new Date(storageFilter[1]);
      endDate.setDate(endDate.getDate() + 1);
      endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);
      endDate = endDate.split("-");
      endDate = endDate[0] + endDate[1] + endDate[2];

      var filteredSearch = [];
      for (var s in quotes) {
        var quoteDate = quotes[s].quote_date.replace(/-/g, '');
        if (parseInt(quoteDate) >= parseInt(startDate) && parseInt(quoteDate) <= parseInt(endDate)) {
          filteredSearch.push(quotes[s]);
        }
      }
      quotes = filteredSearch;
    }

  }

  /* if (window.localStorage.reportDepartments != null && window.localStorage.reportDepartments != 'undefined') {

    var storageFilter = JSON.parse(window.localStorage.reportDepartments);
    var filteredSearch = [];
    var isAdded = [];

    for( var s in quotes ) {
      var quoteAdd = false;
      if( quotes[s].range_id != undefined && quotes[s].range_id != null ) {
        var quoteRanges = quotes[s].range_id.split(',');
        if( quotes[s].range_id != null && quotes[s].range_id != undefined ) {
          var departmentRanges = payload.departments;
          var filteredQuotes = [];
          for (var d in departmentRanges) {
            if( storageFilter.indexOf(departmentRanges[d].id) != -1 ) {
              for( var qr in quoteRanges ) {
                var depRanges = departmentRanges[d].ranges;
                if( depRanges.length > 0 && depRanges.indexOf( quoteRanges[qr] ) != -1 && isAdded.indexOf( quotes[s].id ) == -1  ) {
                  isAdded.push( quotes[s].id );
                  filteredSearch.push(quotes[s]);
                }
              }
            }
          }
        }
      }
    }

    quotes = filteredSearch;
  } */

  if (window.localStorage.reportBranches != null && window.localStorage.reportBranches != 'undefined') {
    var storageFilter = JSON.parse(window.localStorage.reportBranches);
    var filteredSearch = [];
    for (var s in quotes) {
      if( storageFilter.indexOf(quotes[s].store_name) != -1 ) {
        filteredSearch.push(quotes[s]);
      }
    }
    quotes = filteredSearch;
  }

  if (window.localStorage.reportOriginators != null && window.localStorage.reportOriginators != 'undefined' && ignoreFilters == false) {
    var storageFilter = JSON.parse(window.localStorage.reportOriginators);
    var filteredSearch = [];
    for (var s in quotes) {
      for (var c in storageFilter) {
        if (storageFilter[c] == quotes[s].originator) {
          filteredSearch.push(quotes[s]);
        }
      }
    }
    quotes = filteredSearch;
  }

  state.quoteList = payload.quotes;
  state.quoteSearchList = quotes;
  state.quoteSearchListSet = quotes;

  var lowestDate = '99999999';
  var highestDate = '0';

  for (var v in quotes) {
    var quoteDate = quotes[v].quote_date.replace(/-/g, "");
    var hDate = highestDate.replace(/-/g, "");
    var lDate = lowestDate.replace(/-/g, "");
    if (quoteDate > hDate) {
      highestDate = quotes[v].quote_date;
    }
    if (quoteDate < lDate) {
      lowestDate = quotes[v].quote_date;
    }
  }

  if (lowestDate != '99999999' ) {
    var newLowestDate = new Date(lowestDate);
    newLowestDate.setDate(newLowestDate.getDate() - 1);
    lowestDate = newLowestDate.toISOString().substr(0, 10);
  }

  var fStatus = [];
  var fDepartment = [];
  var fOriginator = [];
  var fProjects = [];
  var fSpecifier = [];
  var fUser = [];
  var fCompany = [];
  var fVendor = [];
  var fBranch = [];

  //payload.quotes = state.quoteSearchList;
  if( payload.loggedUser.department != '' && payload.loggedUser.department != null  /*&& ignoreFilters == false*/) {

    /*var userDepartments = payload.loggedUser.department.split(',');

    var depFilter = [];

    for( var s in quotes ) {
      var quoteAdd = false;
      if( quotes[s].range_id != undefined && quotes[s].range_id != null ) {
        var quoteRanges = quotes[s].range_id.split(',');
        if( quotes[s].range_id != null && quotes[s].range_id != undefined ) {
          var departmentRanges = payload.departments;
          var filteredQuotes = [];
          for (var d in departmentRanges) {
            if( userDepartments.indexOf(departmentRanges[d].id.toString()) != -1 ) {
              for( var qr in quoteRanges ) {
                var depRanges = departmentRanges[d].ranges;
                if( depRanges.indexOf( quoteRanges[qr] )  ) {
                  quoteAdd = true
                }
              }
            }
          }
        }
      }
      if( quoteAdd == true ) {
        depFilter.push( quotes[s] );
      }
    }
    quotes = depFilter;*/
  }

  state.quoteSearchList = quotes;
  state.quoteSearchListSet = quotes;

  // check for logged in department user
  for( var s in quotes ) {
    var objItem = quotes[s];
    var returnDepartment = 0;
    var departmentName = [];
    if( objItem.range_id != null && objItem.range_id != undefined ) {
      var departmentRanges = payload.departments;
      var filteredQuotes = [];
      var quoteRanges = objItem.range_id.split(',');
      for( var d in departmentRanges ) {
        for( var qr in quoteRanges ) {
          for( var dr in departmentRanges[d].ranges ) {
            if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
              departmentName.push( departmentRanges[d].id );
            }
          }
        }
      }
      var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
      if( uniqueDepartment.length == 0 ) {
        if( objItem.originator_department != '' && objItem.originator_department != null ) {
          for( var d in payload.departments ) {
            if( payload.departments[d].id == objItem.originator_department ) {
              returnDepartment = payload.departments[d].id;
            }
          }
        } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
          returnDepartment = objItem.departmentUser;
        } else {
          returnDepartment = 0;
        }
      } else if( uniqueDepartment.length > 1 ) {
        if( objItem.originator_department != '' && objItem.originator_department != null ) {
          returnDepartment = objItem.originator_department;
        } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
          returnDepartment = objItem.departmentUser;
        } else {
          returnDepartment = 0;
        }
      } else {
        returnDepartment = uniqueDepartment[0];
      }
    } else {
      if( objItem.originator_department != '' && objItem.originator_department != null ) {
        returnDepartment = objItem.originator_department;
      } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
        returnDepartment = objItem.departmentUser;
      } else {
        returnDepartment = 0;
      }
    }
    if( returnDepartment != 0 ) {
      fDepartment.push(returnDepartment);
    }
    /*if( quotes[s].range_id != undefined && quotes[s].range_id != null ) {
      var quoteRanges = quotes[s].range_id.split(',');
      if( quotes[s].range_id != null && quotes[s].range_id != undefined ) {
        var departmentRanges = payload.departments;
        var filteredQuotes = [];
        for (var d in departmentRanges) {
          //if( departmentRanges[d].id == storageFilter[c] ) {
            for (var qr in quoteRanges) {
              for (var dr in departmentRanges[d].ranges) {
                if (quoteRanges[qr] == departmentRanges[d].ranges[dr]) {
                  //filteredSearch.push(quotes[s]);
                  fDepartment.push(departmentRanges[d].id);
                }
              }
            }
          //}
        }
      }
    }*/
  }
  var savedStores = [];

  if( payload.branches != undefined && payload.branches.length > 0 ) {
    for( var b in payload.branches ) {
      if( payload.branches[b].code != null ) {
        savedStores[payload.branches[b].code.toString()] = payload.branches[b].name;
      }
    }
  }

  for ( var q in quotes ) {
    fStatus.push(quotes[q].status);
    fOriginator.push(quotes[q].originator);
    fProjects.push(quotes[q].project);
    fSpecifier.push(quotes[q].specifier);
    fVendor.push(quotes[q].vendorName);
    if( quotes[q].store_name != 'N/A' ) {
      var storeName = { code: quotes[q].store_name, name:  savedStores[quotes[q].store_name] };
      if( storeName == '' ) {
        storeName = { code: quotes[q].store_name, name: quotes[q].store_name };
      }
      fBranch.push(storeName);
    }




    /*for (var s in quotes) {
      if( quotes[s].range_id != undefined && quotes[s].range_id != null ) {
        var quoteRanges = quotes[s].range_id.split(',');
          if( quotes[s].range_id != null && quotes[s].range_id != undefined ) {
            var departmentRanges = payload.departments;
            var filteredQuotes = [];
            for (var d in departmentRanges) {
              //if( departmentRanges[d].id == storageFilter[c] ) {
                for (var qr in quoteRanges) {
                  for (var dr in departmentRanges[d].ranges) {
                    if (quoteRanges[qr] == departmentRanges[d].ranges[dr]) {
                      //filteredSearch.push(quotes[s]);
                      fDepartment.push(departmentRanges[d].id);
                    }
                  }
                }
              //}
            }
          }
      }
    }*/

    if (quotes[q].customer_name != 'undefined' && quotes[q].customer_name != null) {
      var customerObj = quotes[q].customer_name.split('-');
      if (customerObj.length == 2) {
        fCompany.push(customerObj[0]);
        fUser.push(customerObj[1]);
      } else if (customerObj.length == 1) {
        fUser.push(customerObj[0]);
      }
    }

  }

  var filterOriginator = [{ id: 'all', name: 'All' }];
  var filterStatus = [{ id: 'all', name: 'All' }];
  var filterProject = [{ id: 'all', name: 'All' }];
  var filterSpecifier = [{ id: 'all', name: 'All' }];
  var filterUser = [{ id: 'all', name: 'All' }];
  var filterCompany = [{ id: 'all', name: 'All' }];
  var filterVendor = [{ id: 'all', name: 'All' }];
  var filterDepartment = [{ id: 'all', name: 'All' }];
  var filterStore = [{ id: 'all', name: 'All' }];

  var currentTrend = '';

  if (window.localStorage.searchOrder != undefined && window.localStorage.searchOrder != null ) {
    currentTrend = JSON.parse(window.localStorage.searchOrder)
    if ( currentTrend[0] != '' ) {
      currentTrend = currentTrend[0];
    } else {
      currentTrend = currentTrend[1];
    }
  }

  for (var q in payload.quotes) {

    var addO = '';
    var addS = '';
    var addP = '';
    var addF = '';
    var addV = '';
    var addD = '';
    var addB = '';

    /*if (payload.quotes[q].vendorName != 'None' ) {
      var addV = '';
    }*/

    /*if (payload.quotes[q].customer_name != 'undefined' && payload.quotes[q].customer_name != null) {
      var customerObj = payload.quotes[q].customer_name.split(' - ');
      if (customerObj.length == 2) {

        if (customerObj[0] != '' && customerObj[0] != null) {
          var addC = { id: customerObj[0], name: customerObj[0] };
          filterCompany.push(addC);
        }

        if (customerObj[1] != '' && customerObj[1] != null) {
          var addU = { id: customerObj[1], name: customerObj[1] };
          filterUser.push(addU);
        }

      } else if (customerObj.length == 1) {
        var addU = { id: customerObj[0], name: customerObj[0] };
        filterUser.push(addU);
      }
    }*/

    if (currentTrend == 'store' && payload.quotes[q].store_name != 'N/A') {
      var addB = { id: payload.quotes[q].store_name, name: payload.quotes[q].store_name };
      //} else if (fBranch.indexOf(payload.quotes[q].store_name) != -1 && payload.quotes[q].store_name != 'N/A') {
    } else if( payload.quotes[q].store_name != 'N/A' ) {
      for( var b in fBranch ) {
        if( fBranch[b].code == payload.quotes[q].store_name ) {
          var addB = { id: fBranch[b].code, name: fBranch[b].name };
        }
      }
      //var addB = { id: payload.quotes[q].store_name, name: payload.quotes[q].store_name };
    }

    if (currentTrend == 'department') {
      //var addD = { id: payload.quotes[q].vendorName, name: payload.quotes[q].vendorName };
    } else {
      for( var d in payload.departments ) {
        if( fDepartment.indexOf( payload.departments[d].id ) != -1 ) {
          var addD = { id: payload.departments[d].id, name: payload.departments[d].name };
          filterDepartment.push( addD );
        }
      }
    }

    if (currentTrend == 'vendor') {
      var addV = { id: payload.quotes[q].vendorName, name: payload.quotes[q].vendorName };
    } else if (fVendor.indexOf(payload.quotes[q].vendorName) != -1) {
      var addV = { id: payload.quotes[q].vendorName, name: payload.quotes[q].vendorName };
    }

    if (currentTrend == 'originators') {
      var addO = { id: payload.quotes[q].originator, name: payload.quotes[q].orig_name };
    } else if (fOriginator.indexOf(payload.quotes[q].originator) != -1) {
      var addO = { id: payload.quotes[q].originator, name: payload.quotes[q].orig_name };
    }

    if (payload.quotes[q].status != '') {
      if ( currentTrend == 'status' ) {
        var addS = { id: payload.quotes[q].status, name: payload.quotes[q].status };
      } else if (fStatus.indexOf(payload.quotes[q].status) != -1) {
        var addS = { id: payload.quotes[q].status, name: payload.quotes[q].status };
      }
    }

    if( payload.quotes[q].range_id != null && payload.quotes[q].range_id != undefined ) {
      var departmentRanges = payload.departments;
      var filteredQuotes = [];
      var quoteRanges = payload.quotes[q].range_id.split(',');
      for (var d in departmentRanges) {
        for (var qr in quoteRanges) {
          for (var dr in departmentRanges[d].ranges) {
            if (quoteRanges[qr] == departmentRanges[d].ranges[dr]) {
              if ( currentTrend == 'department' ) {
                fDepartment.push(departmentRanges[d].id);
                var addD = { id: departmentRanges[d].id, name: departmentRanges[d].name };
                filterDepartment.push(addD);
              } else if (fDepartment.indexOf(departmentRanges[d].id) != -1) {
                // } else if (fDepartment.indexOf(departmentRanges[d].id) != -1) {
                fDepartment.push(departmentRanges[d].id);
                var addD = { id: departmentRanges[d].id, name: departmentRanges[d].name };
                filterDepartment.push(addD);
              }
            }
          }
        }
      }
    }

    if (payload.quotes[q].project != 'project') {
      if (currentTrend == '') {
        var addP = { id: payload.quotes[q].project, name: payload.quotes[q].project };
      } else if (fProjects.indexOf(payload.quotes[q].project) != -1) {
        var addP = { id: payload.quotes[q].project, name: payload.quotes[q].project };
      }
    }
    if (payload.quotes[q].specifier != '' && payload.quotes[q].specifier != null) {
      if (currentTrend == 'specifier') {
        var addF = { id: payload.quotes[q].specifier, name: payload.quotes[q].specifier };
      } else if (fSpecifier.indexOf(payload.quotes[q].specifier) != -1) {
        var addF = { id: payload.quotes[q].specifier, name: payload.quotes[q].specifier };
      }
    }
    if (payload.quotes[q].customer_name != 'undefined' && payload.quotes[q].customer_name != null) {
      var customerObj = payload.quotes[q].customer_name.split(' - ');
      if (customerObj.length == 2) {

        if (customerObj[0] != '' && customerObj[0] != null) {
          if (currentTrend == 'company') {
            var addC = { id: customerObj[0], name: customerObj[0] };
            filterCompany.push(addC);
          } else if (fCompany.indexOf(customerObj[0]) != -1 && customerObj[0] != 'undefined' && customerObj[0] != null) {
            var addC = { id: customerObj[0], name: customerObj[0] };
            filterCompany.push(addC);
          }
        }

        if (customerObj[1] != '' && customerObj[1] != null) {
          if (currentTrend == 'companyuser') {
            var addU = { id: customerObj[1], name: customerObj[1] };
            filterUser.push(addU);
          } else if (fUser.indexOf(customerObj[1]) != -1 && customerObj[1] != 'undefined' && customerObj[1] != null) {
            var addU = { id: customerObj[1], name: customerObj[1] };
            filterUser.push(addU);
          }
        }

      } else if (customerObj.length == 1) {
        if (customerObj[0] != '' && customerObj[0] != null) {
          if (currentTrend == 'companyuser') {
            var addU = { id: customerObj[0], name: customerObj[0] };
            filterUser.push(addU);
          } else if (fUser.indexOf(customerObj[0]) != -1 && customerObj[0] != 'undefined' && customerObj[0] != null) {
            var addU = { id: customerObj[0], name: customerObj[0] };
            filterUser.push(addU);
          }
        }
      }
    }

    if (addB != null && addB != '') {
      filterStore.push(addB);
    }
    if (addO != null && addO != '') {
      filterOriginator.push(addO);
    }
    if ( addS != null && addS != '' ) {
      filterStatus.push(addS);
    }
    if (addP != null && addP != '') {
      filterProject.push(addP);
    }
    if (addF != null && addF != '') {
      filterSpecifier.push(addF);
    }
    if (addV != null && addV != '') {
      filterVendor.push(addV);
    }

  }

  if( ( payload.loggedUser.department_active == true || payload.loggedUser.department_active == 1 ) && ( payload.loggedUser.department_status_share == true || payload.loggedUser.department_status_share == 1 )) {
    var labeledStatuses = [];
    var loadedStatuses = [];
    var hasAddedLevel = [];

    for( var l in state.statusList ) {
      loadedStatuses[state.statusList[l].description] = state.statusList[l].departmentName;
    }

    for( var s in filterStatus ) {
      if( filterStatus[s].id != 'all' ) {

        var objFilter = loadedStatuses[filterStatus[s].name];

        if( objFilter == null ) {
          objFilter = 'General';
        }

        if( hasAddedLevel.indexOf( objFilter ) == -1)  {
          labeledStatuses[objFilter] = [];
          hasAddedLevel.push( objFilter );
        }
        labeledStatuses[objFilter].push({ id: filterStatus[s].id, name: filterStatus[s].name })

        /*if( hasAddedLevel.indexOf( loadedStatuses[filterStatus[s].name] ) == -1)  {
          labeledStatuses[loadedStatuses[filterStatus[s].name]] = [];
          hasAddedLevel.push( loadedStatuses[filterStatus[s].name] );
          console.log(  );
        }
        labeledStatuses[loadedStatuses[filterStatus[s].name]].push({ id: filterStatus[s].id, name: filterStatus[s].name })*/
      }
    }

    filterStatus = [{ id: 'all', name: 'All' }];

    var filterByLabel = [];
    for( var l in labeledStatuses ) {
      if( l == 'General') {
        filterByLabel[l] = labeledStatuses[l];
      }
    }
    for( var l in labeledStatuses ) {
      if( l != 'General') {
        filterByLabel[l] = labeledStatuses[l];
      }
    }

    labeledStatuses = filterByLabel;
    for( var k in labeledStatuses ) {
      filterStatus.push({ header: k});
      for( var s in labeledStatuses[k] ) {
        filterStatus.push({ id: labeledStatuses[k][s].id, name: labeledStatuses[k][s].name});
      }
    }
  }

  state.objQuoteFilters.originators = filterOriginator;
  state.objQuoteFilters.stores = filterStore;
  state.objQuoteFilters.departments = filterDepartment;
  state.objQuoteFilters.status = filterStatus;
  state.objQuoteFilters.projects = filterProject;
  state.objQuoteFilters.specifier = filterSpecifier;
  state.objQuoteFilters.users = filterUser;
  state.objQuoteFilters.company = filterCompany;
  state.objQuoteFilters.lowDate = lowestDate;
  state.objQuoteFilters.hiDate = highestDate;
  state.objQuoteFilters.vendors = filterVendor;

  state.quotesLoaded = true;

  /*var filterUsers = [{ header: 'No company assignment' }]
  var assignment = [];
  for (var q in payload.quotes) {
    if (payload.quotes[q].customer_name != 'undefined' && payload.quotes[q].customer_name != null) {
      var customerObj = payload.quotes[q].customer_name.split(' - ');
      if (customerObj.length == 2) {
        //console.log(customerObj );
        if (customerObj[0] == '' ) {
          filterUsers.push({ id: customerObj[1], name: customerObj[1] });
        } else if (assignment.hasOwnProperty(customerObj[0]) ) {
          assignment[customerObj[0]].push(customerObj[1]);
        } else {
          assignment[customerObj[0]] = [];
          assignment[customerObj[0]].push(customerObj[1]);
        }
      } else if (customerObj.length == 1) {
        if (fUser.indexOf(customerObj[0]) != -1) {
          filterUsers.push({ id: customerObj[0], name: customerObj[0] });
        }
      }
    }
  }

  for (var a in assignment) {
    //if ( fCompany.indexOf(a) != -1 ) {
      filterUsers.push({ header: a });
      for (var x in assignment[a]) {
        //if (fUser.indexOf(assignment[a][x]) != -1) {
          filterUsers.push({ id: assignment[a][x], name: assignment[a][x] });
        //}

      }
    //}

  }*/

  //  state.objQuoteFilters.users = filterUsers;

  state.isLoaded = true;
}

export const fncCustomReportSearch = (state, payload) => {

	var filteredHeaders = [];
	var searchedQuotes = []
	var searchFor = payload.search.toLowerCase();
	for (var n in payload.headers) {
		var strTitle = payload.headers[n].value;
		if (strTitle == 'discount_value') {
			filteredHeaders.push('discount_val');
		} else if (strTitle == 'sub_total') {
			filteredHeaders.push('pricing_subtotal');
		} else if (strTitle == 'vat') {
			filteredHeaders.push('pricing_vat');
		} else if (strTitle == 'total_gross') {
			filteredHeaders.push('pricing_total');
		} else {
			filteredHeaders.push(payload.headers[n].value);
		}
	}

	for (var n in payload.quotes) {
		for (var x in filteredHeaders) {
			if (filteredHeaders[x] == 'pricing_subtotal' || filteredHeaders[x] == 'pricing_vat' || filteredHeaders[x] == 'pricing_total' || filteredHeaders[x] == 'discount_val') {
				var forex = '';
				var finalString = forex + parseFloat(payload.quotes[n][filteredHeaders[x]]).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
				var finalStringPlain = forex + parseFloat(payload.quotes[n][filteredHeaders[x]]).toFixed(2).toString();
				if (finalString.indexOf(searchFor) != -1) {
					searchedQuotes.push(payload.quotes[n]);
					break;
				} else if (finalStringPlain.indexOf(searchFor) != -1) {
					searchedQuotes.push(payload.quotes[n]);
					break;
				}
			} else if (filteredHeaders[x] != 'view' && filteredHeaders[x] != 'forex' && filteredHeaders[x] != 'distribute' && payload.quotes[n][filteredHeaders[x]] != undefined && payload.quotes[n][filteredHeaders[x]].toLowerCase().indexOf(searchFor) != -1) {
				searchedQuotes.push(payload.quotes[n]);
				break;
			}
		}
	}

	localStorage.setItem('reportSearch', payload.search);

	if (payload.dates != '' && searchedQuotes.length > 0) {

		var startDate = new Date(payload.dates[0]);
		startDate.setDate(startDate.getDate() + 1);
		startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);
		startDate = startDate.split("-");
		startDate = startDate[0] + startDate[1] + startDate[2];

		var endDate = new Date(payload.dates[1]);
		endDate.setDate(endDate.getDate() + 1);
		endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);
		endDate = endDate.split("-");
		endDate = endDate[0] + endDate[1] + endDate[2];

		var filteredSearch = [];
		localStorage.setItem('reportDates', payload.dates.toString());

		for ( var s in searchedQuotes ) {
			var quoteDate = searchedQuotes[s].quote_date.replace(/-/g, '');
			if (parseInt(quoteDate) >= parseInt(startDate) && parseInt(quoteDate) <= parseInt(endDate)) {
				filteredSearch.push(searchedQuotes[s]);
			}
		}

		searchedQuotes = filteredSearch;
	} else {
		localStorage.removeItem('reportDates');
	}

	if (payload.originators != '' && searchedQuotes.length > 0) {
		localStorage.setItem('reportOriginators', JSON.stringify(payload.originators));
		var filteredSearch = [];
		for (var s in searchedQuotes) {
			for (var c in payload.originators) {
				if (payload.originators[c] == searchedQuotes[s].originator) {
					filteredSearch.push(searchedQuotes[s]);
				}
			}
		}
		searchedQuotes = filteredSearch;
	} else {
		localStorage.removeItem('reportOriginators');
	}

	if (payload.status != '' && searchedQuotes.length > 0) {
		var filteredSearch = [];
		localStorage.setItem('reportStatus', JSON.stringify(payload.status));
		for (var s in searchedQuotes) {
			for (var c in payload.status) {
				if (payload.status[c] == searchedQuotes[s].status) {
					filteredSearch.push(searchedQuotes[s]);
				}
			}
		}
		searchedQuotes = filteredSearch;
	} else {
		localStorage.removeItem('reportStatus');
	}

	if (payload.projects != '' && searchedQuotes.length > 0) {
		var filteredSearch = [];
		localStorage.setItem('reportProject', JSON.stringify(payload.projects));
		for (var s in searchedQuotes) {
			for (var c in payload.projects) {
				if (payload.projects[c] == searchedQuotes[s].project) {
					filteredSearch.push(searchedQuotes[s]);
				}
			}
		}
		searchedQuotes = filteredSearch;
	} else {
		localStorage.removeItem('reportProject');
	}

	if (payload.users != '' && searchedQuotes.length > 0) {
		var filteredSearch = [];
		localStorage.setItem('reportUsers', JSON.stringify(payload.users));
		for (var s in searchedQuotes) {
			for (var c in payload.users) {
				if (searchedQuotes[s].customer_name != null && searchedQuotes[s].customer_name.indexOf( payload.users[c] ) != -1 ) {
					filteredSearch.push(searchedQuotes[s]);
				}
			}
		}
		searchedQuotes = filteredSearch;
	} else {
		localStorage.removeItem('reportUsers');
	}

	if (payload.company != '' && searchedQuotes.length > 0) {
		var filteredSearch = [];
		localStorage.setItem('reportCompanies', JSON.stringify(payload.company));
		for (var s in searchedQuotes) {
			for (var c in payload.company) {
				if (searchedQuotes[s].customer_name != null && searchedQuotes[s].customer_name.indexOf(payload.company[c]) != -1) {
					filteredSearch.push(searchedQuotes[s]);
				}
			}
		}
		searchedQuotes = filteredSearch;
	} else {
		localStorage.removeItem('reportCompanies');
	}

	if (payload.specifiers != '' && searchedQuotes.length > 0) {
		var filteredSearch = [];
		localStorage.setItem('reportSpecifiers', JSON.stringify(payload.specifiers));
		for (var s in searchedQuotes) {
			for (var c in payload.specifiers) {
				if (searchedQuotes[s].specifiers != null && searchedQuotes[s].specifier == payload.specifiers[c]) {
					filteredSearch.push(searchedQuotes[s]);
				}
			}
		}
		searchedQuotes = filteredSearch;
	} else {
		localStorage.removeItem('reportSpecifiers');
	}

	state.quoteSearchList = searchedQuotes;
	state.quoteSearchListSet = searchedQuotes;
}

export const setTenderList = (state, payload) => {
	state.tenderList = payload.tenders;
}

export const setSpecList = (state, payload) => {
	state.specList = payload;
}

export const setRfcList = (state, payload) => {
	var filteredRfcs = [];
	var objToFilter = [];
	for (var k in state.objRfcFilters) {
		if (state.objRfcFilters[k] !== '' && state.objRfcFilters[k] !== undefined && state.objRfcFilters[k] !== null) {
			objToFilter[k] = state.objRfcFilters[k]
		}
		if (state.objRfcFilters[k] !== '' && state.objRfcFilters[k] !== undefined && state.objRfcFilters[k] !== null) {
			objToFilter[k] = state.objRfcFilters[k]
		}
	}
	for (var p in payload.rfcList.documents) {
		var rfcDate = new Date(payload.rfcList.documents[p].created).toISOString().slice(0, 10);
		var objRfcDate = rfcDate.split("-");
		rfcDate = objRfcDate[0] + objRfcDate[1] + objRfcDate[2];
		var isFilter = true;
		if (objToFilter.hasOwnProperty('rfcNumber')) {
			if (objToFilter['rfcNumber'] != payload.rfcList.documents[p].number + '.' + payload.rfcList.documents[p].version) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('cnNumber')) {
			if (objToFilter['cnNumber'] != payload.rfcList.documents[p].creditNoteNumber) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('srNumber')) {
			if (objToFilter['srNumber'] != payload.rfcList.documents[p].salesReturnNumber) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('status')) {
			if (objToFilter['status'] != payload.rfcList.documents[p].documentStatus) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('customer')) {
			if (objToFilter['customer'] != payload.rfcList.documents[p].customerId) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('originator')) {
			if (objToFilter['originator'] != payload.rfcList.documents[p].originatorId) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('startDate') && isFilter === true) {
			var startDate = new Date(objToFilter['startDate']).toISOString().slice(0, 10);
			var objStartDate = startDate.split("-");
			startDate = objStartDate[0] + objStartDate[1] + objStartDate[2];
			if (parseInt(startDate) > parseInt(rfcDate)) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('endDate') && isFilter === true) {
			var endDate = new Date(objToFilter['endDate']).toISOString().slice(0, 10);
			var objEndDate = endDate.split("-");
			endDate = objEndDate[0] + objEndDate[1] + objEndDate[2];
			if (parseInt(endDate) < parseInt(rfcDate)) {
				isFilter = false;
			}
		}
		if (isFilter == true) {
			filteredRfcs.push(payload.rfcList.documents[p]);
		}
    }
	state.rfcList = filteredRfcs;
	var objStatussesAdded = [];
	var objStatusses = [];
	var objCustomersAdded = [];
	var objCustomers = [];
	var objOriginatorsAdded = [];
	var objOriginators = [];
	if( payload.rfcList.documents ) {
    for (var i = 0; i < payload.rfcList.documents.length; i++) {
      if (typeof payload.rfcList.documents[i] === 'object') {
        if (objStatussesAdded.indexOf(payload.rfcList.documents[i].statusDescription) === -1) {
          objStatussesAdded.push(payload.rfcList.documents[i].statusDescription);
          objStatusses.push({ id: payload.rfcList.documents[i].documentStatus, text: payload.rfcList.documents[i].statusDescription });
        }
        if (objOriginatorsAdded.indexOf(payload.rfcList.documents[i].originator.fullname) === -1) {
          objOriginatorsAdded.push(payload.rfcList.documents[i].originator.fullname);
          objOriginators.push({ id: payload.rfcList.documents[i].originator.id, text: payload.rfcList.documents[i].originator.fullname });
        }
        if (objCustomersAdded.indexOf(payload.rfcList.documents[i].customer.id) === -1) {
          objCustomersAdded.push(payload.rfcList.documents[i].customer.id);
          objCustomers.push({ id: payload.rfcList.documents[i].customer.id, text: payload.rfcList.documents[i].customer.fullname });
        }
      }
    }
  }
	state.rfcStatusses = objStatusses;
	state.rfcOriginators = objOriginators;
	state.rfcCustomers = objCustomers;
}

export const setProductSalesList = (state, payload) => {
	state.productSalesList = payload.sales;
}

export const setStatusList = (state, payload) => {
  for( var s in payload.status ){
    payload.status[s].show = true;
  }
	state.statusList = payload.status;
}

export const setRfcStatusList = (state, payload) => {
	state.rfcStatusList = payload.rfcStatus;
}

export const setObjStatusEdit = (state, payload) => {
	for (let k in payload.data) {
		if (payload.data[k].id === payload.id) {
			var statusString = JSON.stringify(payload.data[k]);
			statusString = statusString.replace(new RegExp('"No"', 'g'), false);
			statusString = statusString.replace(new RegExp('"Yes"', 'g'), true);
			var statusObj = JSON.parse(statusString);
			state.objStatusEdit = statusObj;
		}
	}
	/*
	for (let k in state.statusList) {
		if (state.statusList[k].id === payload.id) {
			var statusString = JSON.stringify(state.statusList[k]);
			statusString = statusString.replace(new RegExp('"No"', 'g'), false);
			statusString = statusString.replace(new RegExp('"Yes"', 'g'), true);
			var statusObj = JSON.parse(statusString);
			state.objStatusEdit = statusObj;
		}
	}
	 */
}

export const setObjRfcStatusEdit = (state, payload) => {
	for (let k in state.rfcStatusList) {
		if (state.rfcStatusList[k].id === payload.id) {
			for (var s in state.rfcStatusList[k]) {
				if (state.rfcStatusList[k][s] == 0) {
					state.rfcStatusList[k][s] = false;
				} else if (state.rfcStatusList[k][s] == 1) {
					state.rfcStatusList[k][s] = true;
				}
			}
			state.objRfcStatusEdit = state.rfcStatusList[k];
		}
	}
}

export const updateStatusList = (state, payload) => {
	var newStatusList = [];
	var updatedId = payload.id;
	for (let k in state.statusList) {
		if (state.statusList[k].id === updatedId) {
			newStatusList.push(payload);
		} else {
			newStatusList.push(state.statusList[k]);
		}
	}
	var statusString = JSON.stringify(newStatusList);
	statusString = statusString.replace(new RegExp('false', 'g'), '"No"');
	statusString = statusString.replace(new RegExp('true', 'g'), '"Yes"');
	var statusObj = JSON.parse(statusString);
	state.statusList = statusObj;
}

export const pushStatusList = (state, payload) => {
	var objAnswer = [];
	objAnswer[0] = 'No';
	objAnswer[1] = 'Yes';
	var addStatusDetails = {
		description: payload.description,
		is_order_status: objAnswer[payload.is_order],
		is_lock: objAnswer[payload.is_lock],
		is_accepted: objAnswer[payload.is_accepted],
		is_tender_winning: objAnswer[payload.is_tender_winning],
		create_invoice: objAnswer[payload.create_invoice],
		is_cancel: objAnswer[payload.is_cancel],
		triggers_notification: objAnswer[payload.triggers_notification],
		tender_status: objAnswer[payload.tender_status],
		order: payload.order,
		style_colour: payload.colour,
		colour_flag: payload.colour_check,
		is_expired: payload.is_expired
	}
	state.statusList.unshift(addStatusDetails);
}

export const setObjQuoteSettings = (state, payload) => {
  var manufacturer = payload.manu;
  payload = payload.columns;
	var n = 1;
    var hasCompany = false
	for (var k in payload) {
		if (payload[k].label == 'Company Name') { hasCompany = true;  }
	}
	var quoteSettings = [];
	var hasStore = false;
	var hasDepartment = false;
	var hasDepartment = false;
	var hasSoNumber = false;
	var hasSurveyType = false;
	var hasCustomerRejectReason = false;
	var hasServiceType = false;
	var hasCustomerRating = false;
	var hasInstallationDateTime = false;
	var hasInstallationDescription = false;
	var hasOnsiteTime = false;
	var hasCustomerTelephone = false;
	var hasCustomerEmail = false;
	var hasJobCompleteDate = false;
	var hasCancellationReason = false;
	var hasStatusDesc = false;
	var hasStatusCancellationReason = false;
	var hasQuoteRegion = false;
	var hasAppointmentDate = false;
	var hasAppointmentTime = false;
	var hasQuoteType = false;
	var hasCalculator = false;
	var hasAddressType = false;
	var hasPoNumbers = false;
	var hasCommercialKam = false;
	var hasCommercialOriginator = false;
	var hasKamRegion = false;
	var hasCustomerRecipient = false;
	var hasVendorRecipient = false;
	var hasLinkedQuotes = false;

	for (var k in payload) {
		payload[k].order = n;
		if (payload[k].width == undefined) {
			payload[k].width = 'auto';
		}
		if (payload[k].id && payload[k].id == 'store_name' ) {
			hasStore = true;
		}
    if (payload[k].id && payload[k].id == 'department' ) {
      hasDepartment = true;
    }
    if (payload[k].id && payload[k].id == 'soNumber' ) {
      hasSoNumber = true;
    }
    if (payload[k].id && payload[k].id == 'survey_type' ) {
      hasSurveyType = true;
    }
    if (payload[k].id && payload[k].id == 'serviceType' ) {
      hasServiceType = true;
    }
    if (payload[k].id && payload[k].id == 'customerRejectReason' ) {
      hasCustomerRejectReason = true;
    }
    if (payload[k].id && payload[k].id == 'addressType' ) {
      hasAddressType = true;
    }
    if (payload[k].id && payload[k].id == 'poNumbers' ) {
      hasPoNumbers = true;
    }
    if( manufacturer == '385889803' ) {

      if (payload[k].id && payload[k].id == 'quoteType' ) {
        hasQuoteType = true;
      }
      if (payload[k].id && payload[k].id == 'calculator' ) {
        hasCalculator = true;
      }
      if (payload[k].id && payload[k].id == 'customerRating' ) {
        hasCustomerRating = true;
      }
      if (payload[k].id && payload[k].id == 'installationDate' ) {
        hasInstallationDateTime = true;
      }
      if (payload[k].id && payload[k].id == 'installationDescription' ) {
        hasInstallationDescription = true;
      }
      if (payload[k].id && payload[k].id == 'onsiteTime' ) {
        hasOnsiteTime = true;
      }
      if (payload[k].id && payload[k].id == 'customerTelephone' ) {
        hasCustomerTelephone = true;
      }
      if (payload[k].id && payload[k].id == 'customerEmail' ) {
        hasCustomerEmail = true;
      }
      if (payload[k].id && payload[k].id == 'jobCompleteDate' ) {
        hasJobCompleteDate = true;
      }
      if (payload[k].id && payload[k].id == 'cancellationReason' ) {
        hasCancellationReason = true;
      }
      if (payload[k].id && payload[k].id == 'status_change_reason' ) {
        hasStatusCancellationReason = true;
      }
      if (payload[k].id && payload[k].id == 'quoteRegion' ) {
        hasQuoteRegion = true;
      }
      if (payload[k].id && payload[k].id == 'appointmentDate' ) {
        hasAppointmentDate = true;
      }
      if (payload[k].id && payload[k].id == 'appointmentTime' ) {
        hasAppointmentTime = true;
      }
      if (payload[k].id && payload[k].id == 'commercialKam' ) {
        hasCommercialKam = true;
      }
      if (payload[k].id && payload[k].id == 'commercialOriginator' ) {
        hasCommercialOriginator = true;
      }
      if (payload[k].id && payload[k].id == 'kamRegion' ) {
        hasKamRegion = true;
      }
      if (payload[k].id && payload[k].id == 'customerRecipient' ) {
        hasCustomerRecipient = true;
      }
      if (payload[k].id && payload[k].id == 'vendorRecipient' ) {
        hasVendorRecipient = true;
      }
      if (payload[k].id && payload[k].id == 'linkedQuotes' ) {
        hasLinkedQuotes = true;
      }
      if( payload[k].id != 'total' && payload[k].id != 'vat' ) {
        quoteSettings.push( payload[k] );
        n++;
      }
    } else {
      quoteSettings.push( payload[k] );
      n++;
    }
		if (payload[k].label == 'Customer Name' && hasCompany == false) {
			var companyName = { id: "company_name", label: "Company Name", checked: false, width: "auto", order: n }
			quoteSettings.push(companyName);
		}
	}
	if ( hasStore == false ) {
		var storeName = { id: "store_name", label: "Store", checked: false, width: "auto", order: n };
        quoteSettings.push(storeName);
	}
  if ( hasQuoteType == false ) {
    var quoteType = { id: "quoteType", label: "Quote Type", checked: false, width: "auto", order: n++ };
    quoteSettings.push(quoteType);
  }
  if ( hasCalculator == false ) {
    var calculator = { id: "calculator", label: "Calculator", checked: false, width: "auto", order: n++ };
    quoteSettings.push(calculator);
  }
  if ( hasDepartment == false ) {
    var departmentName = { id: "department", label: "Department", checked: false, width: "auto", order: n++ };
    quoteSettings.push(departmentName);
  }
  if ( hasPoNumbers == false ) {
    var poNumber = { id: "poNumbers", label: "Purchase Order Number", checked: false, width: "auto", order: n++ };
    quoteSettings.push(poNumber);
  }
  if ( hasSoNumber == false ) {
    var soNumber = { id: "soNumber", label: "Sales Order Number", checked: false, width: "auto", order: n++ };
    quoteSettings.push(soNumber);
  }
  if ( hasServiceType == false ) {
    var serviceType = { id: "serviceType", label: "Service Type", checked: false, width: "auto", order: n++ };
    quoteSettings.push(serviceType);
  }
  if ( hasCustomerRejectReason == false ) {
    var customerRejectReason = { id: "customerRejectReason", label: "Customer Reject Reason", checked: false, width: "auto", order: n++ };
    quoteSettings.push(customerRejectReason);
  }
  if ( hasAddressType == false ) {
    var addressType = { id: "addressType", label: "Delivery Method", checked: false, width: "auto", order: n++ };
    quoteSettings.push(addressType);
  }
  if ( hasCustomerRating == false ) {
    var customerRating = { id: "customerRating", label: "Customer Rating", checked: false, width: "auto", order: n++ };
    quoteSettings.push(customerRating);
  }
  if ( hasInstallationDateTime == false ) {
    var installationDateTime = { id: "installationDate", label: "Installation Date", checked: false, width: "auto", order: n++ };
    quoteSettings.push(installationDateTime);
  }
  if ( hasInstallationDescription == false ) {
    var installationDescription = { id: "installationDescription", label: "Installation Description", checked: false, width: "auto", order: n++ };
    quoteSettings.push(installationDescription);
  }
  if ( hasOnsiteTime == false ) {
    var onsiteTime = { id: "onsiteTime", label: "Onsite Time", checked: false, width: "auto", order: n++ };
    quoteSettings.push(onsiteTime);
  }
  if ( hasJobCompleteDate == false ) {
    var jobCompleteDate = { id: "jobCompleteDate", label: "Job Complete Date", checked: false, width: "auto", order: n++ };
    quoteSettings.push(jobCompleteDate);
  }
  if ( hasCancellationReason == false ) {
    var cancellationReason = { id: "cancellationReason", label: "Cancellation Reason", checked: false, width: "auto", order: n++ };
    quoteSettings.push(cancellationReason);
  }
  if ( hasStatusCancellationReason == false ) {
    var cancellationReason = { id: "status_change_reason", label: "Status Reason", checked: false, width: "auto", order: n++ };
    quoteSettings.push(cancellationReason);
  }
  if ( hasSurveyType == false ) {
    var surveyType = { id: "survey_type", label: "Service Form Type", checked: false, width: "auto", order: n };
    quoteSettings.push(surveyType);
  }
  if ( hasCustomerTelephone == false ) {
    var hasCustomerTelephone = { id: "customerTelephone", label: "Customer Telephone", checked: false, width: "auto", order: n++ };
    quoteSettings.push(hasCustomerTelephone);
  }

  if ( hasCustomerEmail == false ) {
    var hasCustomerEmail = { id: "customerEmail", label: "Customer Email", checked: false, width: "auto", order: n++ };
    quoteSettings.push(hasCustomerEmail);
  }
  if ( hasQuoteRegion == false ) {
    var hasQuoteRegion = { id: "quoteRegion", label: "Region", checked: false, width: "auto", order: n++ };
    quoteSettings.push(hasQuoteRegion);
  }
  if ( hasAppointmentDate == false ) {
    var appointmentDate = { id: "appointmentDate", label: "Appointment Date", checked: false, width: "auto", order: n++ };
    quoteSettings.push(appointmentDate);
  }
  if ( hasAppointmentTime == false ) {
    var appointmentTime = { id: "appointmentTime", label: "Appointment Time", checked: false, width: "auto", order: n++ };
    quoteSettings.push(appointmentTime);
  }
  if ( hasCustomerRecipient == false ) {
    var customerRecipient = { id: "customerRecipient", label: "Customer Recipient", checked: false, width: "auto", order: n++ };
    quoteSettings.push(customerRecipient);
  }
  if ( hasVendorRecipient == false ) {
    var vendorRecipient = { id: "vendorRecipient", label: "Vendor Recipient", checked: false, width: "auto", order: n++ };
    quoteSettings.push(vendorRecipient);
  }
  if ( hasLinkedQuotes == false ) {
    var linkedQuotes = { id: "linkedQuotes", label: "Linked Quotes", checked: false, width: "auto", order: n++ };
    quoteSettings.push(linkedQuotes);
  }
  /*if ( hasCommercialKam == false ) {
    var hasCommercialKam = { id: "commercialKam", label: "Commercial KAM", checked: false, width: "auto", order: n++ };
    quoteSettings.push(hasCommercialKam);
  }
  if ( hasCommercialOriginator == false ) {
    var hasCommercialOriginator = { id: "commercialOriginator", label: "Commercial Coordinator", checked: false, width: "auto", order: n++ };
    quoteSettings.push(hasCommercialOriginator);
  }*/
  if ( hasKamRegion == false ) {
    var kamRegion = { id: "kamRegion", label: "Kam Region", checked: false, width: "auto", order: n++ };
    quoteSettings.push(kamRegion);
  }

	state.objQuoteSettings = quoteSettings;
}

export const setObjUserInfo = (state, payload) => {

	var topLevel = '';
	var topArr = [];
	for ( var r in payload.allRegions ) {
		topArr.push(payload.allRegions[r].type.toLowerCase());
	}

	if ( topArr.indexOf('country') != -1 ) {
		topLevel = 'country';
	} else if (topArr.indexOf('district') != -1) {
		topLevel = 'district';
	} else if (topArr.indexOf('province') != -1) {
		topLevel = 'province';
	} else if (topArr.indexOf('town') != -1) {
		topLevel = 'town';
	} else if (topArr.indexOf('suburb') != -1) {
		topLevel = 'suburb';
	}

	var arr = payload.allRegions;

	var tree = [],
		mappedArr = {},
		arrElem,
		mappedElem;

	for (var i = 0, len = arr.length; i < len; i++) {
		arrElem = arr[i];
		mappedArr[arrElem.id] = arrElem;
		mappedArr[arrElem.id]['children'] = [];
	}


	for (var id in mappedArr) {
		if (mappedArr.hasOwnProperty(id)) {
			mappedElem = mappedArr[id];
			if (mappedElem.parent && mappedArr[mappedElem['parent']] != null ) {
				mappedArr[mappedElem['parent']]['children'].push(mappedElem);
			}
			else {
				tree.push(mappedElem);
			}
		}
	}

	payload.allRegions = tree;

	state.objUserInfo = payload;
}

export const setObjQuoteHistory = (state, payload) => {

  for( var p in payload ) {
    payload[p].showEdit = false;
  }

	state.objQuoteHistory = payload;
}

/*export const fncSetProductSalesReportsFilters = (state, payload) => {
	for( var k in payload.quote_status[0] ) {
		state.objSalesFilterVars.quote_status.push(payload.quote_status[0][k].description);
	}
	for( var k in payload.originator[0] ) {
		var objOriginator = { text: payload.originator[0][k].name, id: payload.originator[0][k].id };
		state.objSalesFilterVars.originator.push(objOriginator);
	}
	for( var k in payload.customer_user[0] ) {
		var objUser = { text: payload.customer_user[0][k].name, id: payload.customer_user[0][k].id };
		state.objSalesFilterVars.customer_user.push(objUser);
	}
	for( var k in payload.customer_company[0] ) {
		var objCompany = { text: payload.customer_company[0][k].name, id: payload.customer_company[0][k].id };
		state.objSalesFilterVars.customer_company.push(objCompany);
	}
}*/

export const fncSetFilterValue = (state, payload) => {
	state.objSalesFilters[payload.key] = payload.val;
}

export const fncActivate = (state, payload) => {
	var newQuoteSettings = [];
	for (var k in state.objQuoteSettings) {
		if (payload.id === state.objQuoteSettings[k].id) {
			state.objQuoteSettings[k].checked = true;
			newQuoteSettings.push(state.objQuoteSettings[k]);
		} else {
			newQuoteSettings.push(state.objQuoteSettings[k]);
		}
	}
	state.objQuoteSettings = newQuoteSettings;
}

export const fncDeactivate = (state, payload) => {
	var newQuoteSettings = [];
	for (var k in state.objQuoteSettings) {
		if (payload.id === state.objQuoteSettings[k].id) {
			state.objQuoteSettings[k].checked = false;
			newQuoteSettings.push(state.objQuoteSettings[k]);
		} else {
			newQuoteSettings.push(state.objQuoteSettings[k]);
		}
	}
	state.objQuoteSettings = newQuoteSettings;
}

export const setRfcHistory = (state, payload) => {
	state.rfcHistory = payload.rfcHistory;
}

export const fncPopulateDiscountList = (state, payload) => {
	var filteredDiscounts = [];
	var objToFilter = [];
	for (var k in state.objDiscountReportFilters) {
		if (state.objDiscountReportFilters[k] !== '' && state.objDiscountReportFilters[k] !== undefined && state.objDiscountReportFilters[k] !== null) {
			objToFilter[k] = state.objDiscountReportFilters[k]
		}
	}
	for (var p in payload) {
		var isFilter = true;
		var discountDate = new Date(payload[p].created).toISOString().slice(0, 10);
		var objDiscountDate = discountDate.split("-");
		discountDate = objDiscountDate[0] + objDiscountDate[1] + objDiscountDate[2];
		if (objToFilter.hasOwnProperty('requestor')) {
			if (objToFilter['requestor'] != payload[p].requestor_id) {
				isFilter = false;
			}
		}
		if (objToFilter['authorizer'] != '' && objToFilter.hasOwnProperty('authorizer') && isFilter === true) {
			if (objToFilter['authorizer'] != payload[p].receiver.id) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('startDate') && isFilter === true) {
			var startDate = new Date(objToFilter['startDate']).toISOString().slice(0, 10);
			var objStartDate = startDate.split("-");
			startDate = objStartDate[0] + objStartDate[1] + objStartDate[2];
			if (parseInt(startDate) > parseInt(discountDate)) {
				isFilter = false;
			}
		}
		if (objToFilter.hasOwnProperty('endDate') && isFilter === true) {
			var endDate = new Date(objToFilter['endDate']).toISOString().slice(0, 10);
			var objEndDate = endDate.split("-");
			endDate = objEndDate[0] + objEndDate[1] + objEndDate[2];
			if (parseInt(endDate) < parseInt(discountDate)) {
				isFilter = false;
			}
		}
		if (isFilter == true) {
			filteredDiscounts.push(payload[p]);
		}
	}
	var filteredPayload = filteredDiscounts;
	var objRequestors = [];
	var objRequestorsSetup = [];
	for (var k in payload) {
		objRequestorsSetup[payload[k].requestor_id] = payload[k].requestor;
	}
	for (var s in objRequestorsSetup) {
		objRequestors.push({ id: objRequestorsSetup[s].id, text: objRequestorsSetup[s].name + ' ' + objRequestorsSetup[s].surname });
	}
	var objAuthorisers = [];
	var objAuthoriserSetup = [];
	for (var k in payload) {
		objAuthoriserSetup[payload[k].receiver.id] = payload[k].receiver;
	}
	for (var s in objAuthoriserSetup) {
		objAuthorisers.push({ id: objAuthoriserSetup[s].id, text: objAuthoriserSetup[s].fullname });
	}
	state.discountAuthorisers = objAuthorisers;
	state.discountRequestors = objRequestors;
	state.discountList = filteredPayload;
}

export const fncEmptyDiscountReport = (state, reload) => {
	state.discountAuthorisers = [];
	state.discountRequestors = [];
	state.discountList = [];
}

export const fncFilterRfc = (state, payload) => {
	state.rfcSearchList = payload;
	var objStatusses = [];
	var objCustomers = [];
	var objOriginators = [];
	for (var i = 0; i < state.rfcSearchList.length; i++) {
		if (objStatusses.indexOf(state.rfcSearchList[i].statusDescription) === -1) {
			objStatusses.push(state.rfcSearchList[i].statusDescription);
		}
		if (objOriginators.indexOf(state.rfcSearchList[i].originator.fullname) === -1) {
			objOriginators.push(state.rfcSearchList[i].originator.fullname);
		}
		if (objCustomers.indexOf(state.rfcSearchList[i].customer.fullname) === -1) {
			objCustomers.push(state.rfcSearchList[i].customer.fullname);
		}
	}
	state.rfcStatusses = objStatusses;
	state.rfcOriginators = objOriginators;
	state.rfcCustomers = objCustomers;
}

export const fncSetPSFilterStatus = (state, payload) => {
	var objStatusses = [];
	for (var s in payload.statusses) {
		objStatusses.push({ id: payload.statusses[s].description, text: payload.statusses[s].description });
	}
	state.psStatusses = objStatusses;
}

export const fncSetPSFilterOriginators = (state, payload) => {
	var objOriginators = [];
	for (var o in payload.originators) {
		objOriginators.push({ id: payload.originators[o].id, text: payload.originators[o].name });
	}
	state.psOriginators = objOriginators;
}

export const fncSetPSFilterCustomers = (state, payload) => {
	var objCustomers = [];
	for (var c in payload.customers) {
		objCustomers.push({ id: payload.customers[c].id, text: payload.customers[c].name });
	}
	state.psCustomers = objCustomers;
}

export const fncSetPSFilterQuoteTenderStatus = (state, payload) => {
	var objStatusses = [];
	objStatusses.push({ id: '0', text: 'Not Adjudicated' });
	objStatusses.push({ id: '1', text: 'Tender Winner' });
	objStatusses.push({ id: '2', text: 'Unsuccessfull' });
	objStatusses.push({ id: '3', text: 'Nominated' });
	state.psTenderStatusses = objStatusses;
}

export const fncSetPSFilterProductTenderStatus = (state, payload) => {
	var objStatusses = [];
	objStatusses.push({ id: '0', text: 'Non Tender Products' });
	objStatusses.push({ id: '1', text: 'Only Representative Products' });
	objStatusses.push({ id: '2', text: 'Only Unrepresentative Products' });
	state.psProductTenderStatusses = objStatusses;
}

export const fncPopulateProductSalesList = (state, payload) => {
	var sales = payload.sales;
	var plistItems = payload.plistItems;
	for (var k in sales) {
		var productRange = 'Unknown Range';
		for (var n in plistItems) {
			if (plistItems[n].pli_code == sales[k].code) {
				productRange = plistItems[n].pli_range;
			}
		}
		sales[k].range = productRange;
	}
	var objRanges = {};
	var objAddedRanges = {};
	var c = 0;
	for (var k in sales) {
		if (objRanges[sales[k].range] == undefined) {
			objRanges[sales[k].range] = [];
			objRanges[sales[k].range]['name'] = sales[k].range;
			objRanges[sales[k].range]['gross'] = 0;
			objRanges[sales[k].range]['quantity'] = 0;
			objRanges[sales[k].range]['discount'] = 0;
			objRanges[sales[k].range]['nett'] = 0;
			objRanges[sales[k].range]['products'] = [];
		}
		var productUom = sales[k].uom;
		for (var n in sales[k].quote_data) {
			objRanges[sales[k].range]['quantity'] += parseInt(sales[k].quote_data[n].total_quantity);
			if (objRanges[sales[k].range]['products'][sales[k].code + ' - ' + sales[k].name] == undefined) {
				objRanges[sales[k].range]['products'][sales[k].code + ' - ' + sales[k].name] = [];
			}
			sales[k].quote_data[n].uom = productUom;
			objRanges[sales[k].range]['products'][sales[k].code + ' - ' + sales[k].name].push(sales[k].quote_data[n]);
		}
		objRanges[sales[k].range]['gross'] += parseFloat(sales[k].gross_total);
		objRanges[sales[k].range]['discount'] += parseFloat(sales[k].discount_total);
		objRanges[sales[k].range]['nett'] += parseFloat(sales[k].nett_total);
	}
	var payload = objRanges;
	var arrSales = [];
	var arrProducts = [];
	var objStatussesAdded = [];
	var objStatusses = [];
	var objTenderStatussesAdded = [];
	var objTenderStatusses = [];
	var objOriginatorsAdded = [];
	var objOriginators = [];
	var objCustomersAdded = [];
	var objCustomers = [];
	var k = 0;
	for (var n in payload) {
		var objSales = { display: true, id: payload[n].name, name: payload[n].name, gross: payload[n].gross, discount: payload[n].discount, nett: payload[n].nett, quantity: payload[n].quantity, children: [] };
		arrSales.push(objSales);
		for (var c in payload[n].products) {
			for (var i in payload[n].products[c]) {
			    /*if( objStatussesAdded.indexOf(payload[n].products[c][i].status) === -1 && payload[n].products[c][i].status != '' ) {
				    objStatussesAdded.push(payload[n].products[c][i].status);
				    objStatusses.push({ id: payload[n].products[c][i].status, text: payload[n].products[c][i].status });
			    }*/
			    /*if( objTenderStatussesAdded.indexOf(payload[n].products[c][i].tender_status) === -1 && payload[n].products[c][i].tender_status != '' ) {
				    objTenderStatussesAdded.push(payload[n].products[c][i].tender_status);
				    objTenderStatusses.push({ id: payload[n].products[c][i].tender_status, text: payload[n].products[c][i].tender_status });
			    }*/
			    /*if( objOriginatorsAdded.indexOf(payload[n].products[c][i].originator_name) === -1 && payload[n].products[c][i].originator_name != '' ) {
				    objOriginatorsAdded.push(payload[n].products[c][i].originator_name);
				    objOriginators.push({ id: payload[n].products[c][i].originator_name, text: payload[n].products[c][i].originator_name });
			    }
			    if( objCustomersAdded.indexOf(payload[n].products[c][i].customer_name) === -1 && payload[n].products[c][i].customer_name != '' ) {
				    objCustomersAdded.push(payload[n].products[c][i].customer_name);
				    objCustomers.push({ id: payload[n].products[c][i].customer_name, text: payload[n].products[c][i].customer_name });
				}*/
				arrProducts.push({
					product_name: c,
					customer_name: payload[n].products[c][i].customer_name,
					date: payload[n].products[c][i].date,
					discount_total: payload[n].products[c][i].discount_total,
					gross_total: payload[n].products[c][i].gross_total,
					nett_total: payload[n].products[c][i].nett_total,
					originator_name: payload[n].products[c][i].originator_name,
					project_name: payload[n].products[c][i].project_name,
					quantity: payload[n].products[c][i].quantity,
					quote_id: payload[n].products[c][i].quote_id,
					quote_no: payload[n].products[c][i].quote_no,
					status: payload[n].products[c][i].status,
					tender_status: payload[n].products[c][i].tender_status,
					uom: payload[n].products[c][i].uom,
					range: payload[n].name
				});
			}
		}
		k++;
	}
	//state.psCustomers = objCustomers;
	//state.psStatusses = objStatusses;
	//state.psTenderStatusses = objTenderStatusses;
	//state.psOriginators = objOriginators;
	state.productSalesList = arrSales;
	state.productSalesSubList = sales;
	state.productSalesProducts = arrProducts;
}

export const fncEmptyProductSalesList = (state, payload) => {
	state.productSalesList = [];
	state.productSalesSubList = [];
	state.productSalesProducts = [];
}

export const fncSetProductSaleRange = (state, payload) => {
	state.productSaleRange = payload;
}

export const fncSetProductSalesSelectProducts = (state, payload) => {
	var productList = [];
	for (var k in payload.products) {
		var singleProduct = { display: true, discount: payload.products[k].discount, gross: payload.products[k].gross, id: payload.products[k].name, name: payload.products[k].name, nett: payload.products[k].nett, products: payload.products[k].products, quantity: payload.products[k].quantity, uom: payload.products[k].uom };
		productList.push(singleProduct);
	}
	for (var k in state.productSalesList) {
		if (state.productSalesList[k].name == payload.range) {
			state.productSalesList[k].children = productList;
		} else {
			state.productSalesList[k].children = [];
		}
	}
	//state.productSalesSelectProducts = productList;
}

export const fncSetSingleQuoteData = (state, payload) => {
	var objQuoteData = [];
	objQuoteData.details = payload.quoteDetails;
	objQuoteData.attachments = payload.quoteAttachments;
	objQuoteData.quote = payload.quote;
	state.singleQuoteData = objQuoteData;


}

export const fncSetStatus = (state, payload) => {
	state.statusList = [];
}

export const fncSetRfcStatus = (state, payload) => {
	state.rfcStatusList = [];
}

export const fncResetStatus = (state, payload) => {
	state.statusList.splice(payload.newIndex, 0, state.statusList.splice(payload.oldIndex, 1)[0]);
	for (var k in state.statusList) {
		state.statusList[k].order = parseInt(k) + 1
	}
}

export const fncResetRfcStatus = (state, payload) => {
	state.rfcStatusList.splice(payload.newIndex, 0, state.rfcStatusList.splice(payload.oldIndex, 1)[0]);
	for (var k in state.rfcStatusList) {
		state.rfcStatusList[k].order = parseInt(k) + 1
	}
}

export const fncSetColumns = (state, payload) => {
	setTimeout(function() {
    state.objQuoteSettings = [];
    state.objQuoteSettings = payload;
  }, 100)
}

export const fncResetColumns = (state, payload) => {
	state.objQuoteSettings.splice(payload.end, 0, state.objQuoteSettings.splice(payload.start, 1)[0]);
	for (var k in state.objQuoteSettings) {
		state.objQuoteSettings[k].order = parseInt(k) + 1
	}
	var newQuoteSettings = state.objQuoteSettings;
	state.objQuoteSettings = [];
	state.objQuoteSettings = newQuoteSettings;
}

export const fncHideProjectSales = (state, payload) => {
	for (var k in state.productSalesList) {
		if (state.productSalesList[k].name == payload) {
			state.productSalesList[k].display = true;
		} else {
			state.productSalesList[k].display = false;
		}
	}
}

export const fncHideProducts = (state, payload) => {
	for (var k in state.productSalesList) {
		if (state.productSalesList[k].children.length > 0) {
			for (var c in state.productSalesList[k].children) {
				state.productSalesList[k].children[c].id = state.productSalesList[k].children[c].name;
				if (state.productSalesList[k].children[c].name == payload) {
					state.productSalesList[k].children[c].display = true;
				} else {
					state.productSalesList[k].children[c].display = false;
				}
			}
		}
	}
}

export const fncEmptyQuoteList = (state, payload) => {
	state.quoteList = [];
	state.quoteSearchList = [];
	state.quoteSearchListSet = [];
}

export const fncSortedQuotes = (state, payload) => {
	state.quoteSearchList = payload;
}

export const fncSetQuoteSettings = (state, payload) => {
	payload.quoteDetails.follow_up_date = payload.quoteDetails.follow_up_date == null ? '' : payload.quoteDetails.follow_up_date.substr(0, 10);
	payload.quoteDetails.delivery_date = payload.quoteDetails.delivery_date == null ? '' : payload.quoteDetails.delivery_date.substr(0, 10);
	payload.quoteDetails.can_expire = payload.quoteDetails.can_expire == 1 ? true : false;
	payload.quoteDetails.soAttachments = payload.soAttachments;
	var quoteDetails = { details: payload.quoteDetails, attachments: payload.quoteAttachments }
	state.quoteSettings = quoteDetails;
}

export const fncSetAvailableReps = (state, payload) => {
	var allReps = [];
	for (var k in payload.l_users) {
		payload.l_users[k].selected = true;
		allReps.push(payload.l_users[k]);
	}
	for (var k in payload.u_users) {
		payload.u_users[k].selected = false;
		allReps.push(payload.u_users[k]);
	}
	state.availableReps = allReps;
}

export const fncEmptySetAvailableReps = (state, payload) => {
	state.availableReps = [];
}

export const fncSetQuoteAttachments = (state, payload) => {
	var quoteDetails = { details: state.quoteSettings.details, attachments: payload }
	state.quoteSettings = quoteDetails;
}

export const fncSetAttachmentActive = (state, payload) => {

  var quoteId = payload.quote;
  var attachmentCount = payload.count;

  for( var s in state.quoteSearchList ) {
    if( state.quoteSearchList[s].id == quoteId ) {
      if( attachmentCount == 0 ) {
        state.quoteSearchList[s].hasAttachments = 0;
      } else {
        state.quoteSearchList[s].hasAttachments = 1;
      }
    }
  }

}

export const fncSetForex = (state, payload) => {
	var ratio = 0;
	for (var k in payload.quotes) {
		ratio = payload.quotes[k];
	}
	var divRatio = 1 / ratio;
	state.currencyRate = divRatio.toFixed(4);
}

export const specStatusList = (state, payload) => {
	return state.specStatusList;
}

export const fncSetSalesOrder = (state, payload) => {

	state.soLoaded = true;

	var showStatus = 0;
	var availableStatus = [];
	for (var s in payload.status) {
		if (payload.status[s].is_checked == 'Yes' || payload.status[s].is_vendor == 'Yes') {
			showStatus = payload.status[s].order
		}
		if (showStatus != 0) {
			availableStatus.push(payload.status[s].description);
		}
	}

	var finalObj = [];
	var finalAllObj = [];
	var inc = 0;

	var salesVault = [];

	for ( var p in payload.sales ) {
		if (salesVault.indexOf(payload.sales[p].quote_id) == -1) {
			//if (availableStatus.indexOf(payload.sales[p].status) != -1) {
				salesVault.push(payload.sales[p].quote_id);
			//}
		}
	}

	for ( var v in salesVault ) {

		var salesOrders = [];
		var addedQuote = [];
		for (var o in payload.sales) {
			if (payload.sales[o].quote_id == salesVault[v] && addedQuote.indexOf(payload.sales[o].quote_id) == -1) {
				addedQuote.push(payload.sales[o].quote_id);
				salesOrders.push({ [payload.sales[o].quote_id]: [] });
			}
		}

		var addedVendors = [];
		for (var s in salesOrders) {
			for (var p in payload.sales) {
				if (payload.sales[p].quote_id == salesVault[v] && addedVendors.indexOf(payload.sales[p].vendor) == -1) {
					addedVendors.push(payload.sales[p].vendor);
					salesOrders[s][payload.sales[p].quote_id].push({ [payload.sales[p].vendor]: [] });
				}
			}
		}

		var addedItems = [];
		for (var s in salesOrders) {
			for (var n in salesOrders[s]) {
				for (var a in salesOrders[s][n]) {
					for (var b in salesOrders[s][n][a]) {
						for (var o in payload.sales) {

							if (payload.sales[o].quote_id == salesVault[v] && payload.sales[o].vendor == b) {
								salesOrders[s][n][a][b].push(payload.sales[o]);
							}
						}
					}
				}
			}
		}

		console.log('SO');
		console.log( salesOrders );

		for (var s in salesOrders) {
			for (var n in salesOrders[s]) {
				for (var a in salesOrders[s][n]) {
					for (var b in salesOrders[s][n][a]) {

						var items = [];
						var price = 0;
						var setDepartment = 0;
						var date = '';
						var currency = 'R';
						var vendor = '';
						var vendorName = '';
						var quoteNo = '';
						var bwSalesOrderNo = '';
						var originatorName = '';
						var quoteAttachment = '';
						var soAttachment = '';
						var customerRating = '';
						var installationDate = '';
						var installationDescription = '';
						var onSiteDate = '';
						var jobComplete = '';
						var jobCancelled = '';
						var customer = '';
						var createdBy = '';
						var orderNo = '';
						var ordered = '';
						var soNo = '';
						var quoteId = '';
						var status = '';
            var soCount = '';
						var fullname = '';
						var email = '';
						var contactnum = '';
						var pricelist = '';
						var purchaseOrder = '';
						var responsibleReps = '';
						var productNames = [];
						var productCodes = [];
						var metaData = '';
						var soId = 0;
						for (var c in salesOrders[s][n][a][b]) {
							if (salesOrders[s][n][a][b][c].override_currency_sym != null) {
								currency = salesOrders[s][n][a][b][c].override_currency_sym;
							}
							vendor = salesOrders[s][n][a][b][c].vendor;
							for (var v in payload.vendors) {
								if (vendor == payload.vendors[v].id ) {
									vendorName = payload.vendors[v].name;
								}
							}
							quoteNo = salesOrders[s][n][a][b][c].quote_no;
              setDepartment = salesOrders[s][n][a][b][c].department;
							bwSalesOrderNo = salesOrders[s][n][a][b][c].bwSalesOrderNo;
              originatorName = salesOrders[s][n][a][b][c].originatorName;
              quoteAttachment = salesOrders[s][n][a][b][c].quoteAttachment;
              soAttachment = salesOrders[s][n][a][b][c].soAttachment;
							customer = salesOrders[s][n][a][b][c].customer;
              createdBy = salesOrders[s][n][a][b][c].created_by;
							orderNo = salesOrders[s][n][a][b][c].orderNo;
							ordered = salesOrders[s][n][a][b][c].ordered;
							//soNo = 'SO' + salesOrders[s][n][a][b][c].vendor + '/' + salesOrders[s][n][a][b][c].quote_id;
              soNo = String(salesOrders[s][n][a][b][c].quote_id) + String(salesOrders[s][n][a][b][c].customer);
              soNo = soNo.padEnd(12, '0');
							pricelist = salesOrders[s][n][a][b][c].pricelist;
							quoteId = salesOrders[s][n][a][b][c].quote_id;
              soCount = salesOrders[s][n][a][b][c].soCount;
							status = salesOrders[s][n][a][b][c].status;
							email = salesOrders[s][n][a][b][c].email;
							purchaseOrder = salesOrders[s][n][a][b][c].poNumber;
              responsibleReps = salesOrders[s][n][a][b][c].responsible_rep_list;
							contactnum = salesOrders[s][n][a][b][c].contactnum;
							fullname = salesOrders[s][n][a][b][c].name + ' ' + salesOrders[s][n][a][b][c].surname;
							items.push(salesOrders[s][n][a][b][c]);
							date = salesOrders[s][n][a][b][c].created.substr(0, 10);
							price = price + parseFloat(salesOrders[s][n][a][b][c].price * salesOrders[s][n][a][b][c].quantity);
							productNames.push(salesOrders[s][n][a][b][c].itemName);
							productCodes.push(salesOrders[s][n][a][b][c].code);
              customerRating = salesOrders[s][n][a][b][c].rating;
              onSiteDate = salesOrders[s][n][a][b][c].onSiteDate;
              jobComplete = salesOrders[s][n][a][b][c].jobComplete;
              jobCancelled = salesOrders[s][n][a][b][c].jobCancelled;
              metaData = salesOrders[s][n][a][b][c].meta_data;
              soId = salesOrders[s][n][a][b][c].soId;

              // check for discount
              var discount = parseFloat(salesOrders[s][n][a][b][c].discount * salesOrders[s][n][a][b][c].quantity);
                  price = price - discount;
						}

            finalAllObj.push({ setDepartment: setDepartment, soId: soId, metaData: metaData, id: inc, date: date, total: price.toFixed(2), pricelist: pricelist, email: email, contactnum: contactnum, fullname: fullname, status: status, soCount: soCount, quoteId: quoteId, quoteNo: quoteNo, orderNo: orderNo, ordered: ordered, items: items, itemCount: items.length, currency: currency, vendor: vendor, vendorName: vendorName, soNo: soNo, bwSalesOrderNo: bwSalesOrderNo, createdBy: createdBy, customer: customer, originatorName: originatorName, quoteAttachment: quoteAttachment, soAttachment: soAttachment, productNames: productNames, productCodes: productCodes, customerRating: customerRating, onSiteDate: onSiteDate, jobComplete: jobComplete, jobCancelled: jobCancelled, purchaseOrder: purchaseOrder, responsibleReps: responsibleReps});
            //finalAllObj.push({ setDepartment: setDepartment, soId: soId, metaData: metaData, id: inc, date: date, total: price.toFixed(2), pricelist: pricelist, email: email, contactnum: contactnum, fullname: fullname, status: status, soCount: soCount, quoteId: quoteId, quoteNo: quoteNo, orderNo: orderNo, ordered: ordered, items: items, itemCount: items.length, currency: currency, vendor: vendor, vendorName: vendorName, soNo: soNo, bwSalesOrderNo: bwSalesOrderNo, createdBy: createdBy, customer: customer, originatorName: originatorName, quoteAttachment: quoteAttachment, soAttachment: soAttachment, productNames: productNames, productCodes: productCodes, customerRating: customerRating, onSiteDate: onSiteDate, jobComplete: jobComplete, jobCancelled: jobCancelled, purchaseOrder: purchaseOrder, responsibleReps: responsibleReps , delivery_date_api: delivery_date_api,manufacturer_date_api:manufacturer_date_api, installationDate:installationDate});

						if (payload.userType == 6) {
							if (vendor == payload.userVendor[0].vendor) {
                finalObj.push({ setDepartment: setDepartment, soId: soId, metaData: metaData, id: inc, date: date, total: price.toFixed(2), pricelist: pricelist, email: email, contactnum: contactnum, fullname: fullname, status: status, soCount: soCount, quoteId: quoteId, quoteNo: quoteNo, orderNo: orderNo, ordered: ordered, items: items, itemCount: items.length, currency: currency, vendor: vendor, vendorName: vendorName, soNo: soNo, bwSalesOrderNo: bwSalesOrderNo, createdBy: createdBy, customer: customer, originatorName: originatorName, quoteAttachment: quoteAttachment, soAttachment: soAttachment, productNames: productNames, productCodes: productCodes, customerRating: customerRating, onSiteDate: onSiteDate, jobComplete: jobComplete, jobCancelled: jobCancelled, purchaseOrder: purchaseOrder, responsibleReps: responsibleReps });
								inc++;
							}
						} else {
              finalObj.push({ setDepartment: setDepartment, soId: soId, metaData: metaData, id: inc, date: date, total: price.toFixed(2), pricelist: pricelist, email: email, contactnum: contactnum, fullname: fullname, status: status, soCount: soCount, quoteId: quoteId, quoteNo: quoteNo, orderNo: orderNo, ordered: ordered, items: items, itemCount: items.length, currency: currency, vendor: vendor, vendorName: vendorName, soNo: soNo, bwSalesOrderNo: bwSalesOrderNo, createdBy: createdBy, customer: customer, originatorName: originatorName, quoteAttachment: quoteAttachment, soAttachment: soAttachment, productNames: productNames, productCodes: productCodes, customerRating: customerRating, onSiteDate: onSiteDate, jobComplete: jobComplete, jobCancelled: jobCancelled, purchaseOrder: purchaseOrder, responsibleReps: responsibleReps });
							inc++;
						}
					}
				}
			}
		}
	}

  console.log('Final');
  console.log( finalObj );

	// now we need to do the department deets
  if( finalObj.length > 0 ) {
      for( var o in finalObj ) {

        var filterDepartments = [];
        var returnDepartment = 'N/A';
        var returnDepartmentId = 0;

        var departmentName = [];
        var departmentId = [];

        // check for product code first
        var productCodes = [];

        var item = finalObj[o];
        for( var i in item.items ) {
          if( item.items[i].code != null && productCodes.indexOf(item.items[i].code) == -1 ) {
            productCodes.push(item.items[i].code);
          }
        }

        var hasDepartment = false;

        if( productCodes.length > 0 ) {
          for( var d in payload.passedRoot.Departments.departmentList ) {
            if( payload.passedRoot.Departments.departmentList[d].product_codes != null ) {
              if( payload.passedRoot.Departments.departmentList[d].product_codes.length > 0 ) {
                for( var c in payload.passedRoot.Departments.departmentList[d].product_codes ) {
                  for( var p in productCodes ) {
                    if( productCodes[p] == payload.passedRoot.Departments.departmentList[d].product_codes[c].value ) {
                      returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                      returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                      filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name
                      hasDepartment = true;
                    }
                  }
                }
              }
            }
          }
        }

        var objItem = item;

        if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == false ) {
          var departmentRanges = payload.passedRoot.Departments.departmentList;
          var filteredQuotes = [];
          var quoteRanges = objItem.range_id.split(',');
          for( var d in departmentRanges ) {
            for( var qr in quoteRanges ) {
              for( var dr in departmentRanges[d].ranges ) {
                if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                  departmentName.push( departmentRanges[d].name );
                  departmentId.push( departmentRanges[d].id );
                }
              }
            }
          }
          var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
          var uniqueDepartmentId = departmentId.filter((v, i, a) => a.indexOf(v) === i);
          if( uniqueDepartment.length == 0 ) {
            if( objItem.originator_department != '' && objItem.originator_department != null ) {
              for( var d in payload.passedRoot.Departments.departmentList ) {
                if( payload.passedRoot.Departments.departmentList[d].id == objItem.originator_department ) {
                  returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                  returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                  filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                  hasDepartment = true;
                }
              }
            } else {
              if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                for( var d in payload.passedRoot.Departments.departmentList ) {
                  if( payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser ) {
                    returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                    returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                    filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                    hasDepartment = true;
                  }
                }
              } else {
                var productCodes = [];

                if( objItem.product_codes != false && objItem.product_codes != undefined ) {
                  var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                  if( line_item_data.length > 0 ) {
                    for( var l in line_item_data ) {
                      if( typeof line_item_data[l] == 'string' ) {
                        var lineObj = line_item_data[l];
                      } else {
                        var lineObj = JSON.parse( line_item_data[l]);
                      }
                      //var lineObj = JSON.parse(JSON.parse( line_item_data[l] ));

                      if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                        productCodes.push(lineObj.product_code);
                      }
                    }
                  }
                }

                if( productCodes.length > 1 ) {
                  returnDepartment = 'N/A';
                  returnDepartmentId = 0;
                  hasDepartment = true;
                } else {
                  for( var d in this.departmentList ) {
                    if( payload.passedRoot.Departments.departmentList[d].product_codes && payload.passedRoot.Departments.departmentList[d].product_codes.length > 0 ) {
                      for( var c in payload.passedRoot.Departments.departmentList[d].product_codes ) {
                        if( productCodes[0] == payload.passedRoot.Departments.departmentList[d].product_codes[c].value ) {
                          returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                          returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                          filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                          hasDepartment = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          } else if( uniqueDepartment.length > 1 ) {
            if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in payload.passedRoot.Departments.departmentList ) {
                if( payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                  returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                  filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                  hasDepartment = true;
                }
              }
            } else {
              returnDepartment = 'N/A';
              returnDepartmentId = 0;
              filterDepartments[0] = 'N/A';
              hasDepartment = true;
            }
          } else {
            returnDepartment = uniqueDepartment[0];
            returnDepartmentId = uniqueDepartmentId[0];
            hasDepartment = true;
          }
        }

        if( hasDepartment == false ) {
          if (objItem.originator_department != '' && objItem.originator_department != null) {
            for (var d in payload.passedRoot.Departments.departmentList) {
              if (payload.passedRoot.Departments.departmentList[d].id == objItem.originator_department) {
                returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
              }
            }
          } else {
            if (objItem.departmentUser != '' && objItem.departmentUser != null) {
              for (var d in payload.passedRoot.Departments.departmentList) {
                if (payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser) {
                  returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                  returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                  filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                }
              }
            } else {
              returnDepartment = 'N/A';
              returnDepartmentId = 0;
              filterDepartments[0] = 'N/A';
            }
          }
        }

        finalObj[o].departmentId = returnDepartmentId;
        finalObj[o].departmentName = returnDepartment;

      }
  }

  if( finalAllObj.length > 0 ) {
    for( var o in finalAllObj ) {

      var filterDepartments = [];
      var returnDepartment = 'N/A';
      var returnDepartmentId = 0;

      var departmentName = [];
      var departmentId = [];

      // check for product code first
      var productCodes = [];

      var item = finalAllObj[o];
      for( var i in item.items ) {
        if( item.items[i].code != null && productCodes.indexOf(item.items[i].code) == -1 ) {
          productCodes.push(item.items[i].code);
        }
      }

      var hasDepartment = false;

      if( productCodes.length > 0 ) {
        for( var d in payload.passedRoot.Departments.departmentList ) {
          if( payload.passedRoot.Departments.departmentList[d].product_codes != null ) {
            if( payload.passedRoot.Departments.departmentList[d].product_codes.length > 0 ) {
              for( var c in payload.passedRoot.Departments.departmentList[d].product_codes ) {
                for( var p in productCodes ) {
                  if( productCodes[p] == payload.passedRoot.Departments.departmentList[d].product_codes[c].value ) {
                    returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                    returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                    filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name
                    hasDepartment = true;
                  }
                }
              }
            }
          }
        }
      }

      var objItem = item;

      if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == false ) {
        var departmentRanges = payload.passedRoot.Departments.departmentList;
        var filteredQuotes = [];
        var quoteRanges = objItem.range_id.split(',');
        for( var d in departmentRanges ) {
          for( var qr in quoteRanges ) {
            for( var dr in departmentRanges[d].ranges ) {
              if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                departmentName.push( departmentRanges[d].name );
                departmentId.push( departmentRanges[d].id );
              }
            }
          }
        }
        var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
        var uniqueDepartmentId = departmentId.filter((v, i, a) => a.indexOf(v) === i);
        if( uniqueDepartment.length == 0 ) {
          if( objItem.originator_department != '' && objItem.originator_department != null ) {
            for( var d in payload.passedRoot.Departments.departmentList ) {
              if( payload.passedRoot.Departments.departmentList[d].id == objItem.originator_department ) {
                returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                hasDepartment = true;
              }
            }
          } else {
            if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in payload.passedRoot.Departments.departmentList ) {
                if( payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                  returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                  filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                  hasDepartment = true;
                }
              }
            } else {
              var productCodes = [];

              if( objItem.product_codes != false && objItem.product_codes != undefined ) {
                var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                if( line_item_data.length > 0 ) {
                  for( var l in line_item_data ) {
                    if( typeof line_item_data[l] == 'string' ) {
                      var lineObj = line_item_data[l];
                    } else {
                      var lineObj = JSON.parse( line_item_data[l]);
                    }
                    //var lineObj = JSON.parse(JSON.parse( line_item_data[l] ));

                    if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                      productCodes.push(lineObj.product_code);
                    }
                  }
                }
              }

              if( productCodes.length > 1 ) {
                returnDepartment = 'N/A';
                returnDepartmentId = 0;
                hasDepartment = true;
              } else {
                for( var d in this.departmentList ) {
                  if( payload.passedRoot.Departments.departmentList[d].product_codes && payload.passedRoot.Departments.departmentList[d].product_codes.length > 0 ) {
                    for( var c in payload.passedRoot.Departments.departmentList[d].product_codes ) {
                      if( productCodes[0] == payload.passedRoot.Departments.departmentList[d].product_codes[c].value ) {
                        returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                        returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                        filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                        hasDepartment = true;
                      }
                    }
                  }
                }
              }
            }
          }
        } else if( uniqueDepartment.length > 1 ) {
          if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
            for( var d in payload.passedRoot.Departments.departmentList ) {
              if( payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser ) {
                returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                hasDepartment = true;
              }
            }
          } else {
            returnDepartment = 'N/A';
            returnDepartmentId = 0;
            filterDepartments[0] = 'N/A';
            hasDepartment = true;
          }
        } else {
          returnDepartment = uniqueDepartment[0];
          returnDepartmentId = uniqueDepartmentId[0];
          hasDepartment = true;
        }
      }

      if( hasDepartment == false ) {
        if (objItem.originator_department != '' && objItem.originator_department != null) {
          for (var d in payload.passedRoot.Departments.departmentList) {
            if (payload.passedRoot.Departments.departmentList[d].id == objItem.originator_department) {
              returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
              returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
              filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
            }
          }
        } else {
          if (objItem.departmentUser != '' && objItem.departmentUser != null) {
            for (var d in payload.passedRoot.Departments.departmentList) {
              if (payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser) {
                returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
              }
            }
          } else {
            returnDepartment = 'N/A';
            returnDepartmentId = 0;
            filterDepartments[0] = 'N/A';
          }
        }
      }

      finalAllObj[o].departmentId = returnDepartmentId;
      finalAllObj[o].departmentName = returnDepartment;

    }
  }

	state.salesOrderList = finalObj;
	state.salesOrderListAll = finalAllObj;

	/*if (window.localStorage.soDate != '' && window.localStorage.soDate != null) {

		var soDate = window.localStorage.soDate.split(',');
		var finalFilterList = [];

		var startDate = new Date(soDate[0]);
		startDate.setDate(startDate.getDate() + 1);
		startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);
		startDate = startDate.split("-");
		startDate = startDate[0] + startDate[1] + startDate[2];

		var endDate = new Date(soDate[1]);
		endDate.setDate(endDate.getDate() + 1);
		endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);
		endDate = endDate.split("-");
		endDate = endDate[0] + endDate[1] + endDate[2];

		for (var s in finalObj) {
			var quoteDate = finalObj[s].date.replace(/-/g, '');
			if (parseInt(quoteDate) >= parseInt(startDate) && parseInt(quoteDate) <= parseInt(endDate)) {
				finalFilterList.push(finalObj[s]);
			}
		}
		finalObj = finalFilterList;
	}*/

  /*if (window.localStorage.soVendors != '' && window.localStorage.soVendors != null) {
    var vendors = window.localStorage.soVendors.split(',');
    var finalFilterList = [];
    for (var s in finalObj) {
      for (var p in vendors) {
        if (vendors[p] == finalObj[s].vendor) {
          finalFilterList.push(finalObj[s]);
        }
      }
    }
    finalObj = finalFilterList;
  }*/

  /*if (window.localStorage.soStores != '' && window.localStorage.soStores != null) {
    var stores = window.localStorage.soStores.split(',');
    var finalFilterList = [];
    for (var s in finalObj) {
      for (var p in stores) {
        var parsedItem = JSON.parse( finalObj[s].items[0].line_item_data );
        if( stores[p] == 'na' && ( parsedItem.store_id == undefined || parsedItem.store_id == null ) ) {
          finalFilterList.push(finalObj[s]);
        } else if( parsedItem.store_id != undefined && parsedItem.store_id != null ) {
          if( parsedItem.store_id == stores[p] ) {
            finalFilterList.push(finalObj[s]);
          }
        }
      }
    }
    finalObj = finalFilterList;
  }*/
	/*if (window.localStorage.soStatus != '' && window.localStorage.soStatus != null) {
		var allStatusses = [];
		for (var v in finalObj) {
			for (var i in finalObj[v].items) {
				allStatusses[finalObj[v].items[i].statusId] = finalObj[v].items[i].status;
			}
		}
		var status = window.localStorage.soStatus.split(',');
		var finalFilterList = [];
		for (var s in finalObj) {
			for (var p in status) {
				if (allStatusses[status[p]] == finalObj[s].status) {
					finalFilterList.push(finalObj[s]);
				}
			}
		}
		finalObj = finalFilterList;
	}*/

  /*if (window.localStorage.soDepartment != '' && window.localStorage.soDepartment != null) {
    var departments = window.localStorage.soDepartment.split(',');
    var finalFilterList = [];
    for (var s in finalObj) {
      for (var d in departments) {
        if (departments[d] == finalObj[s].departmentId) {
          finalFilterList.push(finalObj[s]);
        }
      }
    }
    finalObj = finalFilterList;
  }*/

  state.salesOrderListFilter = finalObj;

  var soFiltered = [];
  for( var fo in finalObj ) {
    if( payload.rootState.objAuthorize.indexOf('VENDOR_FACTORY') != -1 ) {
      if( finalObj[fo].bwSalesOrderNo != '' && finalObj[fo].bwSalesOrderNo != 'N/A' ) {
        soFiltered.push( finalObj[fo] );
      }
    } else {
      soFiltered.push( finalObj[fo] );
    }
  }

  state.salesOrderListFilter = soFiltered;
  // state.salesOrderListFilter = finalObj;

	var filterVendor = [];
	var filterStatus = [];
	var lowestDate = '99999999';
	var highestDate = '0';

    for (var v in state.salesOrderList) {
        var quoteDate = state.salesOrderList[v].date.replace(/-/g, "");
		var hDate = highestDate.replace(/-/g, "");
		var lDate = lowestDate.replace(/-/g, "");
		if (quoteDate > hDate) {
            highestDate = state.salesOrderList[v].date;
		}
		if (quoteDate < lDate) {
            lowestDate = state.salesOrderList[v].date;
		}
        filterVendor[state.salesOrderList[v].vendor] = state.salesOrderList[v].vendorName;
        for (var i in state.salesOrderList[v].items ) {
            filterStatus[state.salesOrderList[v].items[i].statusId] = state.salesOrderList[v].items[i].status;
		}
	}

  var filterDepartments = [];
  for (var v in state.salesOrderList) {

    var item = state.salesOrderList[v];
    var returnDepartment = 'N/A';
    var returnDepartmentId = 0;

    var departmentName = [];
    var departmentId = [];

    // check for product code first
    var productCodes = [];
    for( var i in item.items ) {
      if( item.items[i].code != null && productCodes.indexOf(item.items[i].code) == -1 ) {
        productCodes.push(item.items[i].code);
      }
    }

    var hasDepartment = false;

    if( productCodes.length > 0 ) {
      for( var d in payload.passedRoot.Departments.departmentList ) {
        if( payload.passedRoot.Departments.departmentList[d].product_codes != null ) {
          if( payload.passedRoot.Departments.departmentList[d].product_codes.length > 0 ) {
            for( var c in payload.passedRoot.Departments.departmentList[d].product_codes ) {
              for( var p in productCodes ) {
                if( productCodes[p] == payload.passedRoot.Departments.departmentList[d].product_codes[c].value ) {
                  returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                  returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                  filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name
                  hasDepartment = true;
                }
              }
            }
          }
        }
      }
    }

    var objItem = item;

    if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == false ) {
      var departmentRanges = payload.passedRoot.Departments.departmentList;
      var filteredQuotes = [];
      var quoteRanges = objItem.range_id.split(',');
      for( var d in departmentRanges ) {
        for( var qr in quoteRanges ) {
          for( var dr in departmentRanges[d].ranges ) {
            if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
              departmentName.push( departmentRanges[d].name );
              departmentId.push( departmentRanges[d].id );
            }
          }
        }
      }
      var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
      var uniqueDepartmentId = departmentId.filter((v, i, a) => a.indexOf(v) === i);
      if( uniqueDepartment.length == 0 ) {
        if( objItem.originator_department != '' && objItem.originator_department != null ) {
          for( var d in payload.passedRoot.Departments.departmentList ) {
            if( payload.passedRoot.Departments.departmentList[d].id == objItem.originator_department ) {
              returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
              returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
              filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
              hasDepartment = true;
            }
          }
        } else {
          if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
            for( var d in payload.passedRoot.Departments.departmentList ) {
              if( payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser ) {
                returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                hasDepartment = true;
              }
            }
          } else {
            var productCodes = [];

            if( objItem.product_codes != false && objItem.product_codes != undefined ) {
              var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
              if( line_item_data.length > 0 ) {
                for( var l in line_item_data ) {
                  if( typeof line_item_data[l] == 'string' ) {
                    var lineObj = line_item_data[l];
                  } else {
                    var lineObj = JSON.parse( line_item_data[l]);
                  }
                  //var lineObj = JSON.parse(JSON.parse( line_item_data[l] ));

                  if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                    productCodes.push(lineObj.product_code);
                  }
                }
              }
            }

            if( productCodes.length > 1 ) {
              returnDepartment = 'N/A';
              returnDepartmentId = 0;
              hasDepartment = true;
            } else {
              for( var d in this.departmentList ) {
                if( payload.passedRoot.Departments.departmentList[d].product_codes && payload.passedRoot.Departments.departmentList[d].product_codes.length > 0 ) {
                  for( var c in payload.passedRoot.Departments.departmentList[d].product_codes ) {
                    if( productCodes[0] == payload.passedRoot.Departments.departmentList[d].product_codes[c].value ) {
                      returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
                      returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
                      filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
                      hasDepartment = true;
                    }
                  }
                }
              }
            }
          }
        }
      } else if( uniqueDepartment.length > 1 ) {
        if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
          for( var d in payload.passedRoot.Departments.departmentList ) {
            if( payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser ) {
              returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
              returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
              filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
              hasDepartment = true;
            }
          }
        } else {
          returnDepartment = 'N/A';
          returnDepartmentId = 0;
          filterDepartments[0] = 'N/A';
          hasDepartment = true;
        }
      } else {
        returnDepartment = uniqueDepartment[0];
        returnDepartmentId = uniqueDepartmentId[0];
        hasDepartment = true;
      }
    }

    if( hasDepartment == false ) {
      if (objItem.originator_department != '' && objItem.originator_department != null) {
        for (var d in payload.passedRoot.Departments.departmentList) {
          if (payload.passedRoot.Departments.departmentList[d].id == objItem.originator_department) {
            returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
            returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
            filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
          }
        }
      } else {
        if (objItem.departmentUser != '' && objItem.departmentUser != null) {
          for (var d in payload.passedRoot.Departments.departmentList) {
            if (payload.passedRoot.Departments.departmentList[d].id == objItem.departmentUser) {
              returnDepartment = payload.passedRoot.Departments.departmentList[d].name;
              returnDepartmentId = payload.passedRoot.Departments.departmentList[d].id;
              filterDepartments[payload.passedRoot.Departments.departmentList[d].id] = payload.passedRoot.Departments.departmentList[d].name;
            }
          }
        } else {
          returnDepartment = 'N/A';
          filterDepartments[0] = 'N/A';
        }
      }
    }
    state.salesOrderList[v].departmentName = returnDepartment;
    state.salesOrderList[v].departmentId = returnDepartmentId;
  }

  state.objSalesOrderFilters.departments = [{ id: 'all', text: 'All' }];
  for ( var d in filterDepartments ) {
    state.objSalesOrderFilters.departments.push({ id: d, text: filterDepartments[d] });
  }

	/*var newLowestDate = new Date(lowestDate);
	newLowestDate.setDate(newLowestDate.getDate() - 1);
	lowestDate = newLowestDate.toISOString().substr(0, 10);*/

	state.objSalesOrderFilters.vendors = [{ id: 'all', text: 'All' }];
	for ( var v in filterVendor ) {
		state.objSalesOrderFilters.vendors.push({ id: v, text: filterVendor[v] });
	}

	state.objSalesOrderFilters.status = [{ id: 'all', text: 'All' }];
	for (var s in filterStatus) {
		state.objSalesOrderFilters.status.push({ id: s, text: filterStatus[s] });
	}

	state.objSalesOrderFilters.lowDate = lowestDate;
	state.objSalesOrderFilters.hiDate = highestDate;

	state.objSalesOrderFilters = state.objSalesOrderFilters;

	var newStatusList = [];
    var oldStatusList = []
	var currStatus = payload.status;

	for ( var s in currStatus ) {
		if (availableStatus.indexOf(currStatus[s].description) != -1) {
			currStatus[s].disabled = false;
			newStatusList.push(currStatus[s]);
		} else {
			currStatus[s].disabled = true;
			newStatusList.push(currStatus[s]);
		}
	}

	state.soStatusList = newStatusList;

}

export const fncPopulateSalesOrdersStatusList = (state, payload) => {
  var showStatus = 0;
  var availableStatus = [];
  for (var s in payload.status) {
    if (payload.status[s].is_checked == 'Yes' || payload.status[s].is_vendor == 'Yes') {
      showStatus = payload.status[s].order
    }
    if (showStatus != 0) {
      availableStatus.push(payload.status[s].description);
    }
  }
  var newStatusList = [];
  var oldStatusList = []
  var currStatus = payload.status;

  for ( var s in currStatus ) {
    if (availableStatus.indexOf(currStatus[s].description) != -1) {
      currStatus[s].disabled = false;
      newStatusList.push(currStatus[s]);
    } else {
      currStatus[s].disabled = true;
      newStatusList.push(currStatus[s]);
    }
  }

  state.soStatusList = newStatusList;
}

export const fncFilterSalesOrderReports = (state, payload) => {

	var filteredSearch = [];
	state.salesOrderListFilter = state.salesOrderList;

	if (payload.date != '') {
		var startDate = new Date(payload.date[0]);
		startDate.setDate(startDate.getDate() + 1);
		startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);
		startDate = startDate.split("-");
		startDate = startDate[0] + startDate[1] + startDate[2];

		var endDate = new Date(payload.date[1]);
		endDate.setDate(endDate.getDate() + 1);
		endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);
		endDate = endDate.split("-");
		endDate = endDate[0] + endDate[1] + endDate[2];

		for (var s in state.salesOrderListFilter) {
			var quoteDate = state.salesOrderListFilter[s].date.replace(/-/g, '');
			if (parseInt(quoteDate) >= parseInt(startDate) && parseInt(quoteDate) <= parseInt(endDate)) {
				filteredSearch.push(state.salesOrderList[s]);
			}
		}
		state.salesOrderListFilter = filteredSearch;
		localStorage.setItem('soDate', payload.date.toString());
	} else {
		localStorage.setItem('soDate', '');
	}

	if (payload.vendors != undefined && payload.vendors.length > 0) {
		var filteredSearch = [];
		for (var s in state.salesOrderListFilter) {
			for (var p in payload.vendors) {
				if (payload.vendors[p] == state.salesOrderListFilter[s].vendor ) {
					filteredSearch.push(state.salesOrderListFilter[s]);
				}
			}
		}
		state.salesOrderListFilter = filteredSearch;
		localStorage.setItem('soVendors', payload.vendors);
	} else {
		localStorage.setItem('soVendors', '');
	}

	var statusReference = [];
	for (var v in state.salesOrderListFilter) {
		for (var i in state.salesOrderListFilter[v].items) {
			statusReference[state.salesOrderListFilter[v].items[i].statusId] = state.salesOrderListFilter[v].items[i].status;
		}
	}

  if (payload.store != undefined && payload.store.length > 0) {
    var filteredSearch = [];
    for (var s in state.salesOrderListFilter) {
      for (var p in payload.store) {
        var parsedItem = JSON.parse( state.salesOrderListFilter[s].items[0].line_item_data );
        if( payload.store == 'na' && ( parsedItem.store_id == undefined || parsedItem.store_id == null ) ) {
          filteredSearch.push(state.salesOrderListFilter[s]);
        } else if( parsedItem.store_id != undefined && parsedItem.store_id != null ) {
          if( parsedItem.store_id == payload.store[p] ) {
            filteredSearch.push(state.salesOrderListFilter[s]);
          }
        }
      }
    }
    state.salesOrderListFilter = filteredSearch;
    localStorage.setItem('soStores', payload.store);
  } else {
    localStorage.setItem('soStores', '');
  }

	if (payload.status != undefined && payload.status.length > 0) {
		var filteredSearch = [];
		for (var s in state.salesOrderListFilter) {
			for (var p in payload.status) {
				if (statusReference[payload.status[p]] == state.salesOrderListFilter[s].status) {
					filteredSearch.push(state.salesOrderListFilter[s]);
				}
			}
		}
		state.salesOrderListFilter = filteredSearch;
		localStorage.setItem('soStatus', payload.status);
	} else {
		localStorage.setItem('soStatus', '');
	}

  if (payload.department != undefined && payload.department.length > 0) {
    var filteredSearch = [];
    for (var s in state.salesOrderListFilter) {
      for (var d in payload.department) {
        if (payload.department[d] == state.salesOrderListFilter[s].departmentId ) {
          filteredSearch.push(state.salesOrderListFilter[s]);
        }
      }
    }
    state.salesOrderListFilter = filteredSearch;
    localStorage.setItem('soDepartment', payload.department);
  } else {
    localStorage.setItem('soDepartment', '');
  }

	var finalObj = state.salesOrderListFilter;

	var filterVendor = [];
	var filterStatus = [];
	var lowestDate = '99999999';
	var highestDate = '0';

	for (var v in state.salesOrderListFilter) {
		var quoteDate = state.salesOrderListFilter[v].date.replace(/-/g, "");
		if (quoteDate > highestDate) {
			highestDate = state.salesOrderListFilter[v].date;
		}
		if (quoteDate < lowestDate) {
			lowestDate = state.salesOrderListFilter[v].date;
		}

		filterVendor[state.salesOrderListFilter[v].vendor] = state.salesOrderListFilter[v].vendorName;
		for (var i in state.salesOrderListFilter[v].items) {
			filterStatus[state.salesOrderListFilter[v].items[i].statusId] = state.salesOrderListFilter[v].items[i].status;
		}
	}

	/*var newLowestDate = new Date(lowestDate);
	newLowestDate.setDate(newLowestDate.getDate() - 2);
	lowestDate = newLowestDate.toISOString().substr(0, 10);*/

	state.objSalesOrderFilters.vendors = [{ id: 'all', text: 'All' }];
	for (var v in filterVendor) {
		state.objSalesOrderFilters.vendors.push({ id: v, text: filterVendor[v] });
	}

	state.objSalesOrderFilters.status = [{ id: 'all', text: 'All' }];
	for (var s in filterStatus) {
		state.objSalesOrderFilters.status.push({ id: s, text: filterStatus[s] });
	}

	/*state.objSalesOrderFilters.lowDate = new Date(highestDate);
	state.objSalesOrderFilters.hiDate = new Date(lowestDate);*/

	state.objSalesOrderFilters = state.objSalesOrderFilters;
}

export const setSalesOrderVendors = (state, payload) => {
	state.salesOrderVendors = payload;
}

export const fncSetSalesOrderColumns = (state, payload, rootState) => {

  var soColumns = [];

  if (window.localStorage.soColumns != undefined) {

    soColumns = JSON.parse(window.localStorage.soColumns);
    var filterColumns = [];
    for (var c in soColumns) {
      if (payload.type == '6') {
        if (soColumns[c].id != 'fullname' && soColumns[c].id != 'email' && soColumns[c].id != 'contactnum') {
          //if( soColumns[c].label == 'Date' ) { soColumns[c].label = 'Quote Date'; }
          filterColumns.push(soColumns[c]);
        }
      } else {
        //if( soColumns[c].label == 'Date' ) { soColumns[c].label = 'Quote Date'; }
        filterColumns.push(soColumns[c]);
      }
    }

    localStorage.setItem('soColumns', JSON.stringify(filterColumns));
    state.soColumns = filterColumns;

  } else {

    if (payload.type == '6' || payload.privileges.indexOf('VENDOR_HIDE_DETAILS') != -1) {
      soColumns.push({"id": "date", "label": "Quote Date", "checked": true, "width": "auto", "order": 1});
      soColumns.push({"id": "vendorName", "label": "Vendor", "checked": true, "width": "auto", "order": 2});
      soColumns.push({"id": "items", "label": "Items", "checked": true, "width": "auto", "order": 3});
      soColumns.push({"id": "status", "label": "Status", "checked": true, "width": "auto", "order": 4});
      soColumns.push({"id": "quoteNo", "label": "Quote No", "checked": true, "width": "auto", "order": 5});
      soColumns.push({"id": "soNo", "label": "Sales order No", "checked": false, "width": "auto", "order": 6});
      soColumns.push({
        "id": "bwSalesOrderNo",
        "label": "BW Sales Order No",
        "checked": false,
        "width": "auto",
        "order": 7
      });
      soColumns.push({"id": "serviceType", "label": "Service Type", "checked": false, "width": "auto", "order": 8});
      soColumns.push({
        "id": "originatorName",
        "label": "Originator Name",
        "checked": false,
        "width": "auto",
        "order": 9
      });
      soColumns.push({"id": "soQty", "label": "Quantity", "checked": false, "width": "auto", "order": 10});
      soColumns.push({"id": "soGlassType", "label": "Glass Type", "checked": false, "width": "auto", "order": 11});
      soColumns.push({"id": "soGlassSize", "label": "Glass Size", "checked": false, "width": "auto", "order": 12});
      soColumns.push({"id": "soBranch", "label": "Store", "checked": false, "width": "auto", "order": 13});
      soColumns.push({"id": "soDepartment", "label": "Department", "checked": false, "width": "auto", "order": 14});
        if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
          soColumns.push({"id": "totalPrice", "label": "Total", "checked": true, "width": "auto", "order": 15});
        }

      } else {
        soColumns.push({"id": "date", "label": "Quote Date", "checked": true, "width": "auto", "order": 1});
        soColumns.push({"id": "vendorName", "label": "Vendor", "checked": true, "width": "auto", "order": 2});
        soColumns.push({"id": "items", "label": "Items", "checked": true, "width": "auto", "order": 3});
        soColumns.push({"id": "status", "label": "Status", "checked": true, "width": "auto", "order": 4});
        soColumns.push({"id": "fullname", "label": "Customer Name", "checked": false, "width": "auto", "order": 5});
        soColumns.push({"id": "email", "label": "Customer Email", "checked": false, "width": "auto", "order": 6});
        soColumns.push({
          "id": "contactnum",
          "label": "Customer Contact",
          "checked": false,
          "width": "auto",
          "order": 7
        });
        soColumns.push({"id": "quoteNo", "label": "Quote No", "checked": true, "width": "auto", "order": 8});
        soColumns.push({"id": "soNo", "label": "Sales order No", "checked": false, "width": "auto", "order": 9});
        soColumns.push({
          "id": "bwSalesOrderNo",
          "label": "BW Sales Order No",
          "checked": false,
          "width": "auto",
          "order": 10
        });
        soColumns.push({"id": "serviceType", "label": "Service Type", "checked": false, "width": "auto", "order": 11});
        soColumns.push({
          "id": "originatorName",
          "label": "Originator Name",
          "checked": false,
          "width": "auto",
          "order": 12
        });
        soColumns.push({"id": "soQty", "label": "Quantity", "checked": false, "width": "auto", "order": 13});
        soColumns.push({"id": "soGlassType", "label": "Glass Type", "checked": false, "width": "auto", "order": 14});
        soColumns.push({"id": "soGlassSize", "label": "Glass Size", "checked": false, "width": "auto", "order": 15});
        soColumns.push({"id": "soBranch", "label": "Store", "checked": false, "width": "auto", "order": 16});
        soColumns.push({"id": "soDepartment", "label": "Department", "checked": false, "width": "auto", "order": 17});
        if (payload.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
          soColumns.push({"id": "totalPrice", "label": "Total", "checked": true, "width": "auto", "order": 18});
        }
      }

      localStorage.setItem('soColumns', JSON.stringify(soColumns));
      state.soColumns = soColumns;

    }
}

export const fncResetSoColumns = (state, payload) => {

	state.soColumns.splice(payload.end, 0, state.soColumns.splice(payload.start, 1)[0]);
	for (var k in state.soColumns) {
		state.soColumns[k].order = parseInt(k) + 1
	}

	if (payload.data != null) {
		state.soColumns = payload.data;
	}

	localStorage.removeItem('soColumns');
	localStorage.setItem('soColumns', JSON.stringify(state.soColumns));

	var soColumns = JSON.parse(window.localStorage.soColumns);
	state.soColumns = [];
	state.soColumns = soColumns;

}

export const emptySoColumns = (state, payload) => {
	state.soColumns = '';
}

export const fncEmptySalesOrders = (state, payload) => {
	state.salesOrderList = [];
}

export const fncSetQuoteReportLoaded = (state, payload) => {
	state.quoteReportLoaded = payload;
}

export const fncSetSoSettings = (state, payload) => {
	state.objSoSettings = payload.attachments;
}

export const fncSetStockAvailability = (state, payload) => {
	state.stockAvailability = payload;
}

export const fncEmptyStock = (state, payload) => {
	state.stockAvailability = '';
}

export const fncEmptyDashboard = (state, payload) => {
	state.statusList = [];
	state.quoteList = [];
}

export const fncIsLoaded = (state, payload) => {
	state.isLoaded = payload;
}

export const fncSetQuoteUsers = (state, payload) => {
  state.quoteUsers = payload.reps.split(',');
}

export const fncSetQuoteListOutright = (state, payload) => {
  state.quoteSearchList = payload;
}

export const setQuoteSettings = (state, payload) => {
  state.objQuoteSettings = [];
  state.columnsLoading = true;
  setTimeout(function() {
    state.objQuoteSettings = payload;
    state.columnsLoading = false;
  },1);
}

export const fncSetColumnsLoading = (state, payload) => {
  state.columnsLoading = payload
}

export const fncSetColumnsSorted = (state, payload) => {
  state.columnsSorted = payload
}

export const fncEmptyQuotesLoaded = (state, payload) => {
  state.quotesLoaded = false;
}

export const fncFilterNeedsReload = (state, payload) => {
  state.filterNeedsReload = payload;
}
export const fncSummaryFilterLoad = (state, payload) => {
  state.summaryFilterLoad = payload;
}

export const fncExcelLoading = (state, payload) => {
  state.excelLoading = payload;
}

export const fncSetSoColumns = (state, payload) => {
  state.soColumns = payload;
}

export const fncSetSoStoreFilters = (state, payload) => {

  state.objSalesOrderFilters.store = [{id: 'all', text: 'All'}];
  for (var s in payload) {
    state.objSalesOrderFilters.store.push({id: s, text: payload[s]});
  }
}

export const fncEmptyStatusList = (state, payload) => {
  state.statusList = [];
}

export const fncEmptyDepartmentList = (state, payload) => {
  state.departmentList = [];
}

export const fncDepartmentStatusFilter = (state, payload) => {
  state.departmentStatusFilter = payload;
}

export const fncSetManufacturerAudits = (state, payload) => {
  var toReturn = [];
  for( var p in payload ) {
    if( toReturn[payload[p].target] == null ) {
       toReturn[payload[p].target] = [];
    }
    toReturn[payload[p].target][payload[p].new_value] = []
    toReturn[payload[p].target][payload[p].new_value]['time'] = payload[p].timsetamp;
    toReturn[payload[p].target][payload[p].new_value]['data'] = payload[p].data;
  }
  state.manufacturerAudits = toReturn;
}
/*export const fncSetStatusFilterList = (state, payload) => {

  console.log( state.statusList );
  // state.statusCount = payload;
  // alert( payload );
}*/

export const fncSetSurveyFiles = (state, payload) => {
  state.surveyFiles.push( payload );
}

export const fncSpliceSurveyImage = (state, payload) => {
  state.surveyFiles.splice( payload );
}

export const fncSetSystemSettings = (state, payload) => {
  state.systemSettings.push( payload );
}

export const fncSetSurveyList = (state, payload) => {
  var surveyList = [];
  var surveyListQuotes = [];
  var surveyListProcess = [];
  for( var s in payload ) {
    surveyList[ payload[s].quote ] = payload[s].department_id;
    surveyListQuotes[ payload[s].quote ] = payload[s].survey_type;
    surveyListProcess[ payload[s].quote ] = payload[s].process_id;
  }
  state.surveyList = surveyList;
  state.surveyListQuotes = surveyListQuotes;
  state.surveyListProcess = surveyListProcess;

}

export const setSurveyProductCodes = (state, payload) => {
  var productCodes = [];
  for( var p in payload ) {
    productCodes.push({ "header": p });
    for( var pc in payload[p] ) {
      productCodes.push({ "product_code": payload[p][pc].product_code });
    }
  }
  state.surveyProductCodes = productCodes;
}

export const fncSetQuoteLinks = (state, payload) => {
  state.quoteLinks = payload;
}

export const fncSetEditLoading = (state, payload) => {
  state.editLoading = payload;
}

export const setSoFilters = (state, payload) => {
  state.soFilters = payload;
}

export const fncFilterNeedsReloadSo = (state, payload) => {
  state.filterNeedsReloadSo = payload;
}

export const fncDoSoExcelDownload = (state, payload) => {
  //this.dispatch('fncReturnExcel');
  //state.soFilters = payload;
}

export const setSoExcelLoading = (state, payload) => {
  state.soExcelLoading = payload;
}

export const setSummaryLoading = (state, payload) => {
  state.summaryLoading = payload;
}

export const setSoReps = (state, payload) => {
  state.soReps = payload;
}

export const setStatusEdit = (state, payload) => {
  state.statusEdit = payload;
}

export const setSummaryStatusList = (state, payload) => {
  state.SummaryStatusList = payload.status;
}

export const setSummaryRoleList = (state, payload) => {
  state.SummaryRoleList = payload.status;
}

export const setTopTabsCount = (state, payload) => {
  state.topTabsCount = payload;
}

export const setTotalPending = (state, payload) => {
  state.totalPending = payload;
}

export const selectTabs = (state, payload) => {
  state.Search_Set_Selected_Tab = payload
}

export const fncSelectedTabWithQuotes = (state, payload) => {
  state.selectedTabWithQuotes = payload;
}

export const setConvertLoading = (state, payload) => {
  state.convertLoading = payload;
}

export const fncUpdateStatusText = (state, payload) => {

  var additionalComments = payload.additionalComments;
  if(payload.status === 'Checked Out - Vendor action required'){
    additionalComments = 'API';
  }
  else if( payload.additionalComments === '' || payload.additionalComments === 'N/A' ) {
    additionalComments = 'N/A';
  }

  document.getElementById(payload.quoteId).innerHTML = payload.status;
  document.getElementById('reason_' + payload.quoteId).innerHTML = additionalComments;
}

export const setNotificationHistoryLoaded = (state, payload) => {
  state.notificationHistoryLoaded = payload
}

export const setNotificationHistory = (state, payload) => {
  state.notificationHistory = payload
}

export const setAllFilters = (state, payload) => {
  state.allFilters = payload;
}

export const setInitialFiltersLoaded = (state, payload) => {
  state.initialFiltersLoaded = payload;
}

export const fncSetCalculatorFilterItems = (state, payload) => {

  var calculatorFilters = {rangeId: payload.rangeId, items: []};

  for( var d in payload.data ) {
    var costPrice = 0;
    if( payload.data[d].cost_price ) {
      costPrice = payload.data[d].cost_price;
    }
    calculatorFilters.items.push({ cost_price: costPrice, purchase_method: payload.data[d].purchase_method, article: payload.data[d].article_number, image: payload.data[d].image, article_description: payload.data[d].description, article_description_vendor: payload.data[d].description, price: payload.data[d].price })
  }

  state.calculatorFilters.push( calculatorFilters );

}

export const setSpineLoading = (state, payload) => {
  state.spineLoading = payload;
}

export const setStoreItems = (state, payload) => {

  var zeroPad = (num, places) => String(num).padStart(places, '0');

  var addedArticles = [];
  var checkArticles = [];

  for (var i in payload.addedItems) {
    if (payload.addedItems[i].deleted == false) {
      addedArticles[zeroPad(payload.addedItems[i]['code'],18)] = zeroPad(payload.addedItems[i]['code'],18);
    }
  }

  var calculatorFilters = {rangeId: payload.rangeId, items: []};

  var finalRangeItems = [];

  for (var i in payload.allItems) {

    if (payload.chunks[zeroPad(payload.allItems[i].article_number, 18)] != undefined && payload.chunks[zeroPad(payload.allItems[i].article_number, 18)].listed == true) {
      var singleItem = payload.allItems[i];

      var costPrice = 0;
      if (singleItem.cost_price) {
        costPrice = singleItem.cost_price;
      }

      var description = singleItem.description;
      if (singleItem.purchase_method == 'm2m') {
        description = 'M2M: ' + singleItem.description;
      }

      if (singleItem.purchase_method != 'm2m') {
        if (addedArticles[zeroPad(singleItem.article_number, 18)] != undefined || addedArticles[singleItem.article_number] != undefined) {

          calculatorFilters.items.push({
            disabled: false,
            article_value: singleItem.description + '||' + singleItem.article_number,
            cost_price: costPrice,
            purchase_method: singleItem.purchase_method,
            article: singleItem.article_number,
            image: singleItem.image,
            article_description: singleItem.description,
            article_description_vendor: description,
            uom: payload.allItems[i].pack_size_uom,
            price: payload.chunks[zeroPad(payload.allItems[i].article_number, 18)].price,
            filter: singleItem.name
          })
        } else {
          calculatorFilters.items.push({
            disabled: false,
            article_value: singleItem.description + '||' + singleItem.article_number,
            cost_price: costPrice,
            purchase_method: singleItem.purchase_method,
            article: singleItem.article_number,
            image: singleItem.image,
            article_description: singleItem.description,
            article_description_vendor: description,
            uom: payload.allItems[i].pack_size_uom,
            price: payload.chunks[zeroPad(payload.allItems[i].article_number, 18)].price,
            filter: singleItem.name
          })
        }
      }

    }
  }

  var hasEntry = false;
  for( var s in state.calculatorFilters ) {
    if( state.calculatorFilters[s].rangeId == payload.rangeId ) {
      hasEntry = true;
      state.calculatorFilters[s].items = calculatorFilters.items;
    }
  }

  if( hasEntry == false ) {
    state.calculatorFilters.push(calculatorFilters);
  }

  state.spineLoading = false;
}

export const setStoreAudits = (state, payload) => {
  state.storeAudits = payload;

}

export const fncSetVendorCodes = (state, payload) => {
  state.vendorListCodes.push({code: payload.code, vendor: payload.vendor});
}

export const fncSetVendorCodesAll = (state, payload) => {
  for( var p in payload ) {
    state.vendorListCodes.push({code: payload[p].article_number, vendor: payload[p].vendor});
  }

}

export const fncSetDisabled = (state, payload) => {

  var zeroPad = (num, places) => String(num).padStart(places, '0');

  var addedArticles = [];

  for (var i in payload.addedItems) {
    if (payload.addedItems[i].deleted == false) {
      addedArticles[zeroPad(payload.addedItems[i]['code'],18)] = zeroPad(payload.addedItems[i]['code'],18);
      addedArticles[payload.addedItems[i]['code']] = payload.addedItems[i]['code'];
      addedArticles[parseInt(payload.addedItems[i]['code'])] = parseInt(payload.addedItems[i]['code']);
    }
  }

  for( var c in state.calculatorFilters ) {
    if( state.calculatorFilters[c].rangeId == payload.rangeId ) {

      for( var i in state.calculatorFilters[c].items ) {
        if( addedArticles[state.calculatorFilters[c].items[i].article] != undefined ) {
          state.calculatorFilters[c].items[i].disabled = false;
        } else {
          state.calculatorFilters[c].items[i].disabled = false;
        }
      }
    }
  }

}

export const fncSetArchivedQuotes = (state, payload) => {
  state.archivedQuotes = payload;
}

export const fncSetSurveyCalculators = (state, payload) => {

  for( var p in payload ) {
    state.surveyCalculators[payload[p].id] = payload[p].id;
  }
}

export const fncSetQuoteApis = (state, payload) => {
  state.quoteApis = payload;
}

export const fncSetQuotesLite = (state, payload) => {
  state.quotesLite = payload;
}

export const fncSetQuotesLiteFilters = (state, payload) => {
  state.quotesLiteFilters = payload;
}

export const fncSetQuoteSingle = (state, payload) => {
  state.quoteSingle = payload;
}

export const fncSetFiltersLoading = (state, payload) => {
  state.filtersLoading = payload;
}

export const fncSetQuoteLiteLoaded = (state, payload) => {
  state.quoteLiteLoaded = payload;
}

export const fncSetQuoteLiteContentClick = (state, payload) => {
  state.quoteLiteContentClick = payload;
}

export const fncSetQuoteLiteContentLoaded = (state, payload) => {
  state.quoteLiteContentLoaded = payload;
}

export const fncSetQuoteRepsLite = (state, payload) => {
  state.quoteRepsLite = payload;
}

export const fncSetLiteColumns = (state, payload) => {

  if( payload.manufacturer == '16777962' || payload.manufacturer == '16777970' ) {

    var setData = JSON.parse( payload.data );
    var newDataSet = false;
    var newExternalSet = false;

    for( var d in setData ) {

        if( setData[d].id == 'grant_total' ) {
          newDataSet = true;
        }
        if( setData[d].id == 'external_ref' ) {
          newExternalSet = true;
        }
    }

    if( newDataSet == false ) {
      setData.push({id: 'grant_total', label: 'Total', checked: true});
      setData.push({id: 'external_ref', label: 'External Quote No', checked: true});
      setData.push({id: 'rep_name', label: 'Rep Name', checked: true});
    } else if( newExternalSet == false ) {
      setData.push({id: 'external_ref', label: 'External Quote No', checked: true});
    }

    payload.data = JSON.stringify(setData);

  }

  state.liteColumns = JSON.parse(payload.data);
}

export const fncResetColumnsLite = (state, payload) => {
  state.liteColumns.splice(payload.end, 0, state.liteColumns.splice(payload.start, 1)[0]);
  for (var k in state.liteColumns) {
    state.liteColumns[k].order = parseInt(k) + 1
  }
  var newQuoteSettings = state.liteColumns;
  state.liteColumns = [];
  state.liteColumns = newQuoteSettings;

}

export const setQuoteSettingsLite = (state, payload) => {
  state.liteColumns = [];
  state.columnsLoading = true;
  setTimeout(function() {
    state.liteColumns = payload;
    state.columnsLoading = false;
  },1);
}

export const fncEmptyLiteColumns = (state, payload) => {
  state.liteColumns = [];
}

export const fncSetLiteFilterLoaded = (state, payload) => {
  state.liteFilterLoaded = payload;
}
